"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2307],{

/***/ 28426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ delivery_guarantee; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/delivery-guarantee.styles.js



const Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: ${props => (0,esm/* getTextColor */.uu)('scratched')(props)};
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.regular')(props)};
`;
const GuaranteeText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  margin-top: 16px;
  line-height: 1.25;
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.bold')(props)};
  color: ${props => (0,esm/* getPaletteColor */.ow)('text.primary')(props)};
  line-height: 1.25;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/content-box.js






const ContentBox = _ref => {
  let {
    isMagaluCompany,
    onLinkClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["isMagaluCompany", "onLinkClick"]);

  const handleDetailsClick = () => {
    return onLinkClick == null ? void 0 : onLinkClick();
  };

  return isMagaluCompany ? /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, /*#__PURE__*/react.createElement(Label, {
    "data-testid": "guaranteelabel"
  }, "Empresa do", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    underline: true,
    display: "inline",
    color: "text.scratched",
    onClick: handleDetailsClick
  }, "Grupo Magalu"), ' ', "que garante sua compra do pedido \xE0 entrega.")) : /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, /*#__PURE__*/react.createElement(Label, {
    "data-testid": "guaranteelabel"
  }, "O Magalu garante a sua compra, do pedido \xE0 entrega.", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    underline: true,
    display: "inline",
    color: "text.scratched",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais")));
};

 false ? 0 : void 0;
ContentBox.defaultProps = {
  id: 'magazineluiza',
  delivery: 'magazineluiza',
  isMagaluCompany: false
};
/* harmony default export */ var content_box = (ContentBox);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/guarantee-details.js






const GuaranteeDetails = ({
  text,
  title
}) => {
  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    p: 16
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(build_esm/* Guarantee */.hzV, {
    mr: 16,
    width: 45,
    height: 35
  }), /*#__PURE__*/react.createElement(Title, {
    "data-testid": "details-title"
  }, title)), /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    p: 1
  }, text == null ? void 0 : text.map((textBlock, index) => /*#__PURE__*/react.createElement(GuaranteeText, {
    key: index
  }, textBlock))));
};

 false ? 0 : void 0;
GuaranteeDetails.defaultProps = {
  title: '',
  text: []
};
/* harmony default export */ var guarantee_details = (GuaranteeDetails);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/delivery-guarantee.js










const DeliveryGuarantee = _ref => {
  let {
    seller,
    showDialog,
    detailsText,
    detailsTitle,
    isMagaluCompany,
    onDetailsOpen,
    onDetailsClose
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["seller", "showDialog", "detailsText", "detailsTitle", "isMagaluCompany", "onDetailsOpen", "onDetailsClose"]);

  const {
    id
  } = seller;
  const [showDetails, setShowDetails] = (0,react.useState)(false);

  const openDetails = e => {
    onDetailsOpen(e);
    setShowDetails(true);
  };

  const closeDetails = e => {
    onDetailsClose(e);
    setShowDetails(false);
  };

  if (id === constants/* DEFAULT_SELLER */.ig) return null;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(content_box, (0,esm_extends/* default */.Z)({
    isMagaluCompany: isMagaluCompany,
    onLinkClick: openDetails
  }, props)), !showDialog && /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    direction: "right",
    visible: showDetails,
    onClickOutside: closeDetails,
    fullScreen: false
  }, /*#__PURE__*/react.createElement(Sidebar/* SidebarHeader */.$, {
    label: isMagaluCompany ? 'Empresa do Grupo Magalu' : 'Entrega e compra garantida',
    align: "left",
    fontSize: 3,
    leftButton: {
      icon: 'back',
      title: 'Voltar para a pagina do produto',
      onClick: closeDetails
    }
  }), /*#__PURE__*/react.createElement(guarantee_details, {
    text: detailsText,
    title: detailsTitle
  })), showDialog && /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    visible: showDetails,
    onClickOutside: closeDetails,
    type: "responsive",
    position: "center",
    width: "350px",
    titleStyle: {
      textAlign: 'center'
    },
    showClose: true
  }, /*#__PURE__*/react.createElement(guarantee_details, {
    text: detailsText,
    title: detailsTitle
  })));
};

 false ? 0 : void 0;
DeliveryGuarantee.defaultProps = {
  seller: {
    id: 'magazineluiza'
  },
  detailsText: [],
  detailsTitle: '',
  showDialog: false,
  isMagaluCompany: false,
  onDetailsOpen: () => {},
  onDetailsClose: () => {}
};
/* harmony default export */ var delivery_guarantee = (DeliveryGuarantee);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/index.js


/***/ }),

/***/ 90713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ fast_filter; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/fast-filter.styles.js




const Container = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100%;
  padding: ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
  ${({
  desktopMode
}) => !desktopMode && styled_components_browser_esm/* css */.iv`
      display: flex;
      justify-content: start;
      overflow-x: scroll;
      scrollbar-width: none;
    `};
`;
const FilterText = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  font-size: ${props => (0,esm/* themeGet */.R)(props.desktopMode ? 'fontSizes.2' : 'fontSizes.0')(props)}px;
  white-space: nowrap;
  color: #8f8f8f;
`;
const LabelHeader = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  padding: ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
`;
const FastFilters = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  justify-content: ${props => props.desktopMode ? 'flex-start' : 'center'};
  align-items: center;
`;
const FilterLink = styled_components_browser_esm/* default.a */.ZP.a`
  text-decoration: none;
  cursor: default;
  justify-content: center;
  display: flex;
`;
const FastFilterItem = styled_components_browser_esm/* default.label */.ZP.label`
  ${(0,esm/* getMediaQuery */.aK)('small')} {
    min-width: 134px;
  }
  min-width: 90px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  scroll-snap-align: center;
  border: ${(0,esm/* themeGet */.R)('borders.0')};
  border-radius: ${(0,esm/* themeGet */.R)('radii.large')};
  align-items: center;
  background: ${props => (0,esm/* getBackgroundColor */.dF)('white')(props)};
  height: ${({
  height
}) => `${height}px`};
  width: fit-content;
  & > img {
    padding: ${(0,esm/* themeGet */.R)('space.2')}px
      ${props => (0,esm/* themeGet */.R)(props.desktopMode ? 'space.3' : 'space.2')}px;
    aspect-ratio: 1/1;
    max-width: 100%;
    max-height: 100%;
  }
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/fast-filter.js







function FastFilter({
  filters = {},
  onItemClick,
  onView,
  desktopMode,
  itemHeight,
  slidesPerView
}) {
  const {
    attributeFilters
  } = filters;
  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0,
    delay: 1000
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onView({
        filters
      });
    }
  }, [inView]);

  const RenderVariations = ({
    children,
    filter
  }) => {
    if (desktopMode && filter.values.length > slidesPerView) {
      return /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
        auto: false,
        showControls: false,
        showArrowControls: true,
        showPartial: false,
        showPartialNextSlide: false,
        gutter: 0,
        slidesPerView: slidesPerView,
        "data-testid": "carousel"
      }, children);
    }

    return /*#__PURE__*/react.createElement(FastFilters, {
      "data-testid": "m-carousel",
      desktopMode: desktopMode,
      gap: desktopMode ? 12 : 2
    }, children);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, attributeFilters.map((filter, idx) => /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LabelHeader, null, /*#__PURE__*/react.createElement(atoms/* Heading */.X6, {
    "data-testid": "header-label",
    as: "h2",
    fontSize: desktopMode ? 18 : 14,
    color: "text.attributeLabel"
  }, filter.label)), /*#__PURE__*/react.createElement(Container, {
    ref: ref,
    "data-testid": "filter-item-container",
    key: idx,
    desktopMode: desktopMode
  }, /*#__PURE__*/react.createElement(RenderVariations, {
    filter: filter
  }, filter == null ? void 0 : filter.values.map(item => /*#__PURE__*/react.createElement(FilterLink, {
    key: item.id,
    role: "button",
    onClick: e => onItemClick(e, item),
    href: item.url || item.href,
    "data-testid": "filter-item-link"
  }, /*#__PURE__*/react.createElement(FastFilterItem, {
    "data-testid": "filter-item-label",
    height: itemHeight,
    desktopMode: desktopMode
  }, item.filterType === 'icon' ? /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    alt: item.label,
    title: item.label,
    "data-testid": "filter-item-image",
    src: item.icon
  }) : /*#__PURE__*/react.createElement(FilterText, {
    px: 2,
    desktopMode: desktopMode,
    "data-testid": "filter-item-text"
  }, item.label)))))))));
}

 false ? 0 : void 0;
FastFilter.defaultProps = {
  filters: {},
  onItemClick: () => {},
  onView: () => {},
  slidesPerView: 5
};
/* harmony default export */ var fast_filter = (FastFilter);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/index.js


/***/ }),

/***/ 63486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ filter_delivery; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/filter-delivery.styles.js


const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  display: flex;
  align-content: center;
  justify-content: ${({
  carousel
}) => carousel ? 'start' : 'center'};
  padding: 12px;
  overflow-x: ${({
  scrollOff
}) => scrollOff ? 'hidden' : 'scroll'};
`;
const DeliveryContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js + 2 modules
var Chip = __webpack_require__(17781);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/filter-delivery.js






const FilterDelivery = ({
  filters,
  onChange,
  hasBorder,
  scrollOff
}) => {
  const renderIcon = slug => {
    const Icons = {
      '24c': 'DeliveryRTomorrow',
      delivery_plus_1: 'FastDelivery',
      store_pickup: 'PickupStore',
      delivery_1h: 'Delivery1h',
      delivery_24h: 'Delivery24h',
      'magalu-entregas': 'DeliveryM',
      'magalu-partner': 'Pin',
      free_shipping: 'DeliveryFree',
      today: 'ExpressDelivery',
      magalu_indica: 'FastDelivery',
      promocao_sazonal_1: 'Christmas',
      promocao_sazonal_2: 'CupomPromotion',
      promocao_sazonal_3: 'Offers',
      promocao_sazonal_4: 'Offers'
    };
    return /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: Icons[slug] || 'FastDelivery'
    });
  };

  return /*#__PURE__*/react.createElement(Container, {
    "data-testid": "delivery-filter-container",
    carousel: (filters == null ? void 0 : filters.length) > 2,
    scrollOff: scrollOff
  }, /*#__PURE__*/react.createElement(DeliveryContainer, null, filters == null ? void 0 : filters.map(({
    label,
    slug,
    selected,
    href
  }) => /*#__PURE__*/react.createElement(Chip/* default */.Z, {
    as: "a",
    type: "checkbox",
    name: "DeliveryFilter",
    startIcon: renderIcon(slug),
    onChange: item => onChange(Object.assign({}, item, {
      href,
      label,
      slug
    })),
    checked: selected,
    href: href,
    value: slug,
    key: slug,
    id: slug,
    hasBorder: hasBorder,
    textMaxWidth: '100%',
    minWidth: '135px',
    maxWidth: '150px',
    padding: '4px',
    gridGap: '6px'
  }, label))));
};

 false ? 0 : void 0;
FilterDelivery.defaultProps = {
  filters: [],
  onChange: () => {},
  scrollOff: false,
  hasBorder: false
};
/* harmony default export */ var filter_delivery = (FilterDelivery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/index.js


/***/ }),

/***/ 66608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ import_taxes; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js + 2 modules
var TagInternational = __webpack_require__(37215);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/dialog.styles.js
var dialog_styles = __webpack_require__(37270);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/import-taxes.styles.js




const LabelTitle = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  margin-bottom: 5px;
`;
const Label = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
`;
const Disclaimer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs({
  fontSize: 3
})`
  line-height: normal;
  font-weight: normal;
  color: ${props => (0,build_esm/* themeGet */.R)('colors.greyishBrown')(props)};
`;
const ImportText = styled_components_browser_esm/* default.div */.ZP.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-weight: normal;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.3')(props)}px;

  color: ${props => (0,build_esm/* themeGet */.R)('colors.greyishBrown')(props)};
  line-height: 18.7px;

  b {
    font-weight: 500;
  }
`;
const ImportButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  border-radius: 12px;
  padding: 11px 100px;
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv)`
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  color: ${props => (0,build_esm/* getPaletteColor */.ow)('text.scratched')(props)};
  line-height: 1.25;
`;
const BreakingLine = styled_components_browser_esm/* default.br */.ZP.br``;
const DialogContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Dialog */.Vq).attrs({
  titleStyle: {
    fontSize: '22px',
    color: '#424A52',
    fontWeight: 700
  }
})`
  max-width: 724px;
  overflow-x: hidden;
`;
const DialogHorizontalRule = (0,styled_components_browser_esm/* default */.ZP)(dialog_styles/* HorizontalRule */.bo)`
  height: 1px;
  max-width: 724px;
  transform: translateX(-16px);
  margin: 24px 0 18px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/content-box.js








const ContentBox = _ref => {
  let {
    onLinkClick,
    isIncludeTaxes,
    totalValueImportTax,
    totalValueICMS
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onLinkClick", "isIncludeTaxes", "totalValueImportTax", "totalValueICMS"]);

  const handleDetailsClick = () => {
    return onLinkClick == null ? void 0 : onLinkClick();
  };

  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, (0,esm_extends/* default */.Z)({
    "data-testid": "content-box"
  }, props), isIncludeTaxes && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(LabelTitle, {
    "data-testid": "titletaxeslabel"
  }, "+ Imposto de importa\xE7\xE3o ", (0,esm/* currencyFormatter */.oB)({
    value: totalValueImportTax
  }), " e ICMS ", (0,esm/* currencyFormatter */.oB)({
    value: totalValueICMS
  }), "."), /*#__PURE__*/react.createElement(Label, {
    "data-testid": "texttaxeslabel"
  }, "Os impostos s\xE3o calculados de acordo com o ", /*#__PURE__*/react.createElement(BreakingLine, null), "Remessa Conforme.", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    display: "inline",
    color: "text.primary",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais"))), !isIncludeTaxes && /*#__PURE__*/react.createElement(Label, {
    "data-testid": "texttaxeslabel"
  }, "Impostos de importa\xE7\xE3o ser\xE3o adicionados ao seguir ", /*#__PURE__*/react.createElement(BreakingLine, null), "com a compra.", ' ', /*#__PURE__*/react.createElement(atoms/* Link */.rU, {
    display: "inline",
    color: "text.primary",
    "data-testid": "learn-more",
    onClick: handleDetailsClick
  }, "Saiba mais")));
};

 false ? 0 : void 0;
ContentBox.defaultProps = {
  onLinkClick: undefined,
  isIncludeTaxes: false
};
/* harmony default export */ var content_box = (ContentBox);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/import-details.js






const ImportDetails = ({
  closeDetails,
  isMobile
}) => {
  return /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flexDirection: "column",
    "data-testid": "detail-text"
  }, /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    p: 16
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flexDirection: isMobile ? 'column' : 'row'
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(stereo_ui_icons_build_esm/* ShipmentInAccordance */.qGg, {
    mr: 16,
    width: 66,
    height: 67
  })), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(Disclaimer, null, "[PRODUTO INTERNACIONAL/COMPRA INTERNACIONAL] Toda mercadoria proveniente do exterior (importada) deve ser objeto de declara\xE7\xE3o de importa\xE7\xE3o e est\xE1 sujeita a tributos federal e estadual."))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, null, /*#__PURE__*/react.createElement(ImportText, null, /*#__PURE__*/react.createElement("span", null, "Com o Remessa Conforme, o programa do governo brasileiro que simplifica o processo de importa\xE7\xE3o, voc\xEA sabe de forma clara o que pagar:"), /*#__PURE__*/react.createElement("span", null, "\u2022 Para compras ", /*#__PURE__*/react.createElement("b", null, "at\xE9 50 d\xF3lares"), ", voc\xEA paga 20% de taxa de importa\xE7\xE3o e o ICMS*, sem taxas extras na alf\xE2ndega."), /*#__PURE__*/react.createElement("span", null, "\u2022 Para compras ", /*#__PURE__*/react.createElement("b", null, "acima de 50,01 d\xF3lares"), ", a taxa de importa\xE7\xE3o \xE9 de 60%, com um desconto de 20 d\xF3lares, al\xE9m do ICMS*. E n\xE3o h\xE1 taxas extras na alf\xE2ndega."), /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement("b", null, "*ICMS:"), " Imposto estadual sobre a circula\xE7\xE3o de produtos e servi\xE7os no Brasil. Al\xEDquota de 17% ou 20% calculada automaticamente de acordo com o estado de destino da mercadoria. Em caso de d\xFAvidas sobre a al\xEDquota consulte a Secretaria da Fazenda do seu estado.")))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    justifyContent: "center",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(DialogHorizontalRule, {
    ruleSize: 1,
    bg: "border.light"
  }), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    justifyContent: "center"
  }, /*#__PURE__*/react.createElement(ImportButton, {
    onClick: closeDetails
  }, "Entendi"))));
};

 false ? 0 : void 0;
ImportDetails.defaultProps = {
  closeDetails: () => {},
  isMobile: false
};
/* harmony default export */ var import_details = (ImportDetails);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/import-taxes.js











const ImportTaxes = _ref => {
  let {
    product,
    onDetailsOpen,
    onDetailsClose,
    isIncludeTaxes,
    isMobile
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["product", "onDetailsOpen", "onDetailsClose", "isIncludeTaxes", "isMobile"]);

  const [showDetails, setShowDetails] = (0,react.useState)(false);
  const showInternationalPurchase = (0,utils/* isInternationalPrice */.xx)(product == null ? void 0 : product.price);

  const openDetails = e => {
    onDetailsOpen(e);
    setShowDetails(true);
  };

  const closeDetails = e => {
    onDetailsClose(e);
    setShowDetails(false);
  };

  if (!showInternationalPurchase) return null;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(TagInternational/* default */.Z, {
    variant: "small"
  }), /*#__PURE__*/react.createElement(content_box, (0,esm_extends/* default */.Z)({
    onLinkClick: openDetails,
    isIncludeTaxes: isIncludeTaxes
  }, props)), isMobile && /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    direction: "right",
    visible: showDetails,
    onClickOutside: closeDetails,
    fullScreen: false
  }, /*#__PURE__*/react.createElement(Sidebar/* SidebarHeader */.$, {
    label: "Compra Internacional",
    align: "left",
    fontSize: 3,
    leftButton: {
      icon: 'back',
      title: 'Voltar para a página do produto',
      onClick: closeDetails
    }
  }), /*#__PURE__*/react.createElement(import_details, {
    isMobile: true,
    closeDetails: closeDetails
  })), !isMobile && /*#__PURE__*/react.createElement(DialogContainer, {
    visible: showDetails,
    onClickOutside: closeDetails,
    position: "center",
    showHorizontalRule: true,
    title: "Compra Internacional",
    showClose: true
  }, /*#__PURE__*/react.createElement(import_details, {
    closeDetails: closeDetails
  })));
};

 false ? 0 : void 0;
ImportTaxes.defaultProps = {
  product: {},
  isMobile: false,
  isIncludeTaxes: false,
  onDetailsOpen: () => {},
  onDetailsClose: () => {}
};
/* harmony default export */ var import_taxes = (ImportTaxes);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/index.js


/***/ }),

/***/ 75057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ letMeKnow; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/fullNameMask.js
var fullNameMask = __webpack_require__(15312);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/emailMask.js
var emailMask = __webpack_require__(13111);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/letMeKnow.styles.js




const Title = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).attrs({
  fontSize: 5,
  fontWeight: 'light'
})``;
const Description = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs({
  fontSize: [0, 1, 2, 2],
  display: 'contents',
  color: 'text.light',
  mY: 3
})``;
const InputLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
  mt: 3,
  mb: 1
})``;
const ErrorMessage = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
  color: 'error',
  mt: 1
})``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/letMeKnow.js














function LetMeKnow({
  errorEmail,
  errorName,
  labelEmail,
  labelName,
  labelNewsletter,
  noticeMeLabel,
  noticeMeLink,
  onSubmit,
  placeholderEmail,
  placeholderName,
  subtitle,
  textSubmitButton,
  title
}) {
  const [newsletter, setNewsletter] = (0,react.useState)(true);
  const [fullName, setFullName] = (0,react.useState)('');
  const [email, setEmail] = (0,react.useState)('');
  const [errors, setErrors] = (0,react.useState)({});
  const validateFullName = react.useCallback(() => {
    const fullNameError = !(0,fullNameMask/* default */.Z)(fullName) ? {
      fullName: errorName
    } : undefined;
    setErrors(_ref => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullName"]);

      return Object.assign({}, errs, fullNameError);
    });
    return fullNameError;
  }, [fullName]);
  const validateEmail = react.useCallback(_email => {
    const emailError = !(0,emailMask/* default */.Z)(_email) ? {
      email: errorEmail
    } : undefined;
    setErrors(_ref2 => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["email"]);

      return Object.assign({}, errs, emailError);
    });
    return emailError;
  }, [email]);
  const clearForm = (0,react.useCallback)(() => {
    setFullName('');
    setEmail('');
    setNewsletter(true);
  }, [fullName, email]);

  const handleSubmit = e => {
    const errs = Object.assign({}, validateFullName(fullName), validateEmail(email));

    if (!Object.entries(errs).length) {
      onSubmit({
        fullName,
        email,
        newsletter
      }, clearForm);
    }

    e.preventDefault();
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    alignItems: "baseline",
    gap: "2",
    mb: "3"
  }, /*#__PURE__*/react.createElement(Title, {
    "data-testid": "let-me-know-title"
  }, title), /*#__PURE__*/react.createElement(Link/* default */.Z, {
    href: noticeMeLink,
    target: "_blank",
    underline: true,
    color: "text.light",
    fontSize: [0, 1, 2, 2]
  }, noticeMeLabel)), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "let-me-know-description"
  }, subtitle), /*#__PURE__*/react.createElement("form", null, /*#__PURE__*/react.createElement(InputLabel, {
    "data-testid": "let-me-know-input-label-name"
  }, labelName), /*#__PURE__*/react.createElement(Input/* default */.Z, {
    "data-testid": "let-me-know-input-name",
    placeholder: placeholderName,
    hasError: !!errors.fullName,
    value: fullName,
    onChange: e => setFullName(e.target.value),
    onFocus: () => setErrors(_ref3 => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["fullName"]);

      return errs;
    }),
    onBlur: e => validateFullName(e.target.value)
  }), /*#__PURE__*/react.createElement(ErrorMessage, {
    "data-testid": "let-me-know-error-name"
  }, errors.fullName), /*#__PURE__*/react.createElement(InputLabel, {
    "data-testid": "let-me-know-input-label-email"
  }, labelEmail), /*#__PURE__*/react.createElement(Input/* default */.Z, {
    "data-testid": "let-me-know-input-email",
    placeholder: placeholderEmail,
    type: "email",
    hasError: !!errors.email,
    value: email,
    onChange: e => setEmail(e.target.value),
    onFocus: () => setErrors(_ref4 => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["email"]);

      return errs;
    }),
    onBlur: e => validateEmail(e.target.value)
  }), /*#__PURE__*/react.createElement(ErrorMessage, {
    "data-testid": "let-me-know-error-email"
  }, errors.email)), /*#__PURE__*/react.createElement(Box/* default */.Z, {
    mt: 15
  }, /*#__PURE__*/react.createElement(Checkbox/* default */.Z, {
    as: Text/* default */.Z,
    fontSize: [1, 2],
    checked: newsletter,
    onChange: e => setNewsletter(e.target.checked)
  }, labelNewsletter)), /*#__PURE__*/react.createElement(Box/* default */.Z, {
    mt: 15
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    "data-testid": "let-me-know-submit",
    full: true,
    onClick: handleSubmit
  }, textSubmitButton)));
}

LetMeKnow.defaultProps = {
  errorEmail: 'Insira o e-mail corretamente.',
  errorName: 'Insira o nome completo corretamente.',
  labelEmail: 'E-mail',
  labelName: 'Nome',
  labelNewsletter: 'Quero receber ofertas e conteúdos por e-mail',
  noticeMeLabel: 'Ver produtos similares',
  onSubmit: undefined,
  placeholderEmail: 'Digite seu e-mail',
  placeholderName: 'Digite seu nome',
  subtitle: 'Avise-me quando estiver disponível',
  textSubmitButton: 'Avise-me',
  title: 'Não disponível'
};
 false ? 0 : void 0;
/* harmony default export */ var letMeKnow = (LetMeKnow);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/index.js


/***/ }),

/***/ 99075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CommissionBadge; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/loyalty-commission-styles.js


const Content = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  text-align: center;
`;
const Title = styled_components_browser_esm/* default.h2 */.ZP.h2`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.4')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.fontSize')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  color: ${props => props.color};
  margin: 10px;
`;
const Description = styled_components_browser_esm/* default.p */.ZP.p`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.display')(props)};
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  margin: 15px 0;
  width: 80%;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/loyalty-commission.js







function CommissionBadge({
  label,
  description,
  value,
  productUrl,
  attributes: {
    color,
    icon,
    textColor
  }
}) {
  const icons = {
    coin: 'Coin',
    lightning: 'Lightning'
  };
  const iconName = icons[icon] || 'Coin';
  const [buttonActive, setButtonActive] = (0,react.useState)(false);
  const [isModalOpen, setModalOpen] = (0,react.useState)(false);

  const toggleModal = e => {
    e.stopPropagation();
    e.preventDefault();
    setModalOpen(!isModalOpen);
  };

  const onClick = link => {
    if (buttonActive) return false;
    setButtonActive(true);
    (0,utils/* copyToClipboard */.vQ)(link);
    return setTimeout(() => setButtonActive(false), 3000);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(molecules/* Loyalty */.mY, {
    hasInfo: true,
    onClick: toggleModal,
    color: color,
    icon: iconName,
    textColor: textColor,
    value: value
  }), /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    visible: isModalOpen,
    onClickOutside: toggleModal,
    position: "center",
    showClose: true,
    type: "alert"
  }, /*#__PURE__*/react.createElement(Content, {
    onClick: e => {
      e.stopPropagation();
      e.preventDefault();
    }
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    alignItems: "center",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: iconName,
    "data-testid": "loyalty-commission-icon",
    width: "25px",
    height: "25px",
    color: color
  }), /*#__PURE__*/react.createElement(Title, {
    id: "loyaltyDialogTitle",
    color: color
  }, label)), /*#__PURE__*/react.createElement(molecules/* Loyalty */.mY, {
    value: value,
    color: color,
    Icon: esm/* Icon */.JO$,
    textColor: textColor
  }), /*#__PURE__*/react.createElement(Description, {
    id: "loyaltyDialogDesc"
  }, description), /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    rounded: true,
    variation: buttonActive ? null : 'outline',
    full: true,
    onClick: () => onClick(productUrl),
    "data-testid": "loyalty-commission-button"
  }, buttonActive ? 'Copiado' : 'Copiar Link'))));
}
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/index.js


/***/ }),

/***/ 60857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MediaGallery_MediaGallery; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaThumbnails.styles.js


const MiniatureItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => ({
  borderWidth: props.selected ? 2 : 1,
  borderColor: props.selected ? 'blue' : 'whisper',
  borderStyle: 'solid',
  borderRadius: 'default',
  padding: 2,
  width: props.smallThumbnails ? '84px' : '110px',
  height: props.smallThumbnails ? '66px' : '110px',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  position: 'relative'
}))`
  & img {
    height: ${props => props.smallThumbnails ? '70px' : '90px'};
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaThumbnails.js









const MediaThumbnails = _ref => {
  let {
    alt,
    title,
    audio,
    images,
    video,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showMedia,
    showMoreTooltip,
    smallThumbnails,
    preload
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["alt", "title", "audio", "images", "video", "imgWidth", "imgHeight", "imgMaxHeight", "onImageClick", "onImageChange", "onAudioClick", "onVideoClick", "showMedia", "showMoreTooltip", "smallThumbnails", "preload"]);

  const [imageSelected, setImageSelected] = (0,react.useState)({
    image: images[0],
    index: 0
  });

  const handleImageClick = index => {
    onImageClick(index);
  };

  (0,react.useEffect)(() => {
    setImageSelected({
      image: images[0],
      index: 0
    });
  }, [images]);
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, (0,esm_extends/* default */.Z)({
    columnGap: 4,
    maxHeight: 614,
    "data-testid": "media-gallery"
  }, props), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    rowGap: 3,
    flexDirection: "column",
    width: "fit-content"
  }, images.slice(0, images.length > 5 ? 4 : images.length).map((image, index) => /*#__PURE__*/react.createElement(MiniatureItem, {
    key: `gallery-img-${index}`,
    selected: index === imageSelected.index,
    smallThumbnails: smallThumbnails
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    alt: alt,
    title: title,
    "data-testid": "media-gallery-image",
    src: image,
    width: 90,
    height: 90,
    onClick: () => setImageSelected({
      image,
      index
    }),
    onMouseOver: () => setImageSelected({
      image,
      index
    })
  }))), images.length > 5 && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    "data-testid": "media-gallery-image-more",
    fontSize: 5,
    fontWeight: "bold",
    borderRadius: "default",
    width: smallThumbnails ? '84px' : '110px',
    height: smallThumbnails ? '66px' : '110px',
    title: showMoreTooltip,
    alignItems: "center",
    justifyContent: "center",
    bg: "background.base",
    color: "text.base",
    cursor: "pointer",
    onClick: () => onImageClick(4)
  }, "+ ", images.length - 4)), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flex: 1,
    maxHeight: 614,
    position: "relative"
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    "data-testid": "image-selected-thumbnail",
    src: imageSelected.image,
    maxHeight: imgMaxHeight,
    width: imgWidth,
    height: imgHeight,
    alt: alt,
    title: title,
    lazy: !preload || imageSelected.index !== 0,
    onClick: () => handleImageClick(imageSelected.index),
    cursor: "pointer"
  }), showMedia && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    gap: 2,
    position: "absolute",
    bottom: 0,
    left: 0,
    "data-testid": "media-gallery-icons"
  }, !!video && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "VideoCircle",
    cursor: "pointer",
    width: "40px",
    height: "40px",
    "data-testid": "media-gallery-video-icon",
    onClick: onVideoClick
  }), !!audio && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "PodcastCircle",
    cursor: "pointer",
    width: "40px",
    height: "40px",
    "data-testid": "media-gallery-audio-icon",
    onClick: onAudioClick
  }))));
};

 false ? 0 : void 0;
MediaThumbnails.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 600,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  alt: '',
  title: '',
  showMoreTooltip: '',
  smallThumbnails: false,
  preload: false
};
/* harmony default export */ var MediaGallery_MediaThumbnails = (MediaThumbnails);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaCarousel.js








const MediaCarousel = _ref => {
  let {
    alt,
    title,
    audio,
    images,
    video,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    counterSeparator,
    showCounter,
    onImageChange,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showMedia,
    lazy,
    preload
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["alt", "title", "audio", "images", "video", "imgWidth", "imgHeight", "imgMaxHeight", "counterSeparator", "showCounter", "onImageChange", "onImageClick", "onAudioClick", "onVideoClick", "showMedia", "lazy", "preload"]);

  const [imagesCounter, setCounter] = (0,react.useState)(1);
  const [dialogVisible, setDialogVisible] = (0,react.useState)();
  const mediaTypeHandler = {
    audio: onAudioClick,
    video: onVideoClick
  };
  const mediaTypeRender = {
    video: /*#__PURE__*/react.createElement(atoms/* Embed */.cx, {
      "data-testid": "media-embed",
      src: video
    }),
    audio: /*#__PURE__*/react.createElement("audio", {
      "data-testid": "media-audio",
      controls: true,
      src: audio
    })
  };

  const toggleDialog = type => {
    const nextType = typeof type === 'string' && ['video', 'audio'].includes(type) ? type : null;
    setDialogVisible(nextType);
  };

  const handleMediaClick = type => {
    const mediaHandler = mediaTypeHandler[type];
    mediaHandler();
    toggleDialog(type);
  };

  const handleImageChange = index => {
    setCounter(index + 1);
    onImageChange(images[index]);
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(atoms/* Box */.xu, (0,esm_extends/* default */.Z)({
    "data-testid": "media-gallery",
    fontSize: 0,
    position: "relative"
  }, props), /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
    lazy: lazy,
    onChange: handleImageChange,
    showControls: false,
    auto: false
  }, images.map((image, index) => /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    height: imgMaxHeight,
    key: `gallery-img-${index}`
  }, /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    alt: alt,
    title: title,
    "data-testid": "media-gallery-image",
    key: `gallery-img-${index}`,
    src: image,
    m: "auto",
    width: imgWidth,
    height: imgHeight,
    maxHeight: imgMaxHeight,
    lazy: !preload || index !== 0,
    onClick: () => onImageClick(index)
  })))), showMedia && /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    "data-testid": "media-gallery-icons",
    position: "absolute",
    bottom: "16px",
    left: "16px",
    columnGap: 2
  }, !!video && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "VideoCircle",
    width: "40px",
    height: "40px",
    onClick: () => handleMediaClick('video'),
    "data-testid": "media-gallery-video-icon"
  }), !!audio && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "PodcastCircle",
    width: "40px",
    height: "40px",
    onClick: () => handleMediaClick('audio'),
    "data-testid": "media-gallery-audio-icon"
  })), showCounter && !!images.length && /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    "data-testid": "media-gallery-counter",
    bg: "background.dark",
    color: "text.lightest",
    position: "absolute",
    bottom: "16px",
    right: "16px",
    paddingX: 2,
    paddingY: 1,
    borderRadius: "default",
    opacity: "85%"
  }, imagesCounter, counterSeparator, images.length)), dialogVisible && /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    title: null,
    position: "center",
    showClose: true,
    onClickOutside: toggleDialog,
    visible: true
  }, mediaTypeRender[dialogVisible]));
};

 false ? 0 : void 0;
MediaCarousel.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 800,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  counterSeparator: ' de ',
  showCounter: true,
  alt: '',
  title: '',
  lazy: false,
  preload: false
};
/* harmony default export */ var MediaGallery_MediaCarousel = (MediaCarousel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/MediaGallery.js







const MediaGallery = _ref => {
  let {
    alt,
    title,
    audios,
    images,
    podcasts,
    videos,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    onImageChange,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showThumbnail,
    showMoreTooltip,
    smallThumbnails,
    preload
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["alt", "title", "audios", "images", "podcasts", "videos", "imgWidth", "imgHeight", "imgMaxHeight", "counterSeparator", "showCounter", "onImageChange", "onImageClick", "onAudioClick", "onVideoClick", "showThumbnail", "showMoreTooltip", "smallThumbnails", "lazy", "preload"]);

  const GalleryType = showThumbnail ? MediaGallery_MediaThumbnails : MediaGallery_MediaCarousel;
  const [video] = videos;
  const [audio] = [...podcasts, ...audios];
  const showMedia = !!video || !!audio;
  return /*#__PURE__*/react.createElement(GalleryType, (0,esm_extends/* default */.Z)({
    alt: alt,
    title: title,
    audio: audio,
    video: video,
    images: images,
    imgWidth: imgWidth,
    imgHeight: imgHeight,
    imgMaxHeight: imgMaxHeight,
    onImageClick: onImageClick,
    onAudioClick: onAudioClick,
    onVideoClick: onVideoClick,
    onImageChange: onImageChange,
    showMedia: showMedia,
    showMoreTooltip: showMoreTooltip,
    smallThumbnails: smallThumbnails,
    preload: preload
  }, props));
};

 false ? 0 : void 0;
MediaGallery.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 800,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  counterSeparator: ' de ',
  showCounter: true,
  alt: '',
  title: '',
  onImageChange: () => {},
  onImageClick: () => {},
  onVideoClick: () => {},
  onAudioClick: () => {},
  showThumbnail: false,
  showMoreTooltip: '',
  smallThumbnails: false,
  lazy: false,
  preload: false
};
/* harmony default export */ var MediaGallery_MediaGallery = (MediaGallery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/index.js


/***/ }),

/***/ 56337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ opinion_snippet_block; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/index.js + 2 modules
var Avatar = __webpack_require__(78045);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/index.js + 2 modules
var MediaReviewCard = __webpack_require__(97949);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/helpers.js
const formatMediaList = (array = [], type) => {
  return array.map(elem => {
    return {
      mediaUrl: elem,
      mediaType: type,
      original: elem.includes('original'),
      processed: elem.includes('processed'),
      thumbnails: elem.includes('thumbnails')
    };
  });
};
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/opinion-snippet-block.styles.js



const Header = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  align-items: center;
  padding: 0 0 ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    padding: 0 0 ${props => (0,build_esm/* themeGet */.R)('space.3')(props)}px;
  }
`;
const ReviewWrapper = styled_components_browser_esm/* default.span */.ZP.span`
  width: 80px;
`;
const ReviewerName = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => (0,build_esm/* themeGet */.R)('colors.darkSilver')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  padding: ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
`;
const SubTitle = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(() => ({
  fontSize: 2
}))`
  color: #69727763;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(() => ({
  fontSize: 3
}))`
  color: ${props => (0,build_esm/* themeGet */.R)('colors.darkSilver')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  line-height: 24px;
  padding: ${props => (0,build_esm/* themeGet */.R)('space.3')(props)}px 0
    ${props => (0,build_esm/* themeGet */.R)('space.3')(props)}px;
  word-break: break-word;
`;
const SeeMore = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
const DateWrapper = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(() => ({
  fontSize: 2
}))`
  color: #69727763;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.tall')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/opinion-snippet-block.js











const renderGallery = (mediasList, openPopup) => {
  return mediasList.map(elem => /*#__PURE__*/react.createElement(MediaReviewCard/* default */.Z, {
    key: `gallery-media-${elem.mediaUrl}`,
    media: elem,
    onClick: () => openPopup(elem.mediaUrl.split('/').reverse()[0]),
    width: "124px",
    height: "124px"
  }));
};

const OpinionSnippetBlock = ({
  review,
  charLimit
}) => {
  const [seeMore, setSeeMore] = (0,react.useState)(false);
  const {
    rating,
    description,
    submissionDate,
    attributes,
    userData,
    product
  } = review;
  const isShortDescription = (description == null ? void 0 : description.length) <= charLimit;
  const [isPopupOpen, setIsPopupOpen] = (0,react.useState)(false);
  const [selectedMedia, setSelectedMedia] = (0,react.useState)(0);
  /**
   * check if it has only digits - in case to be a timestamp
   */

  const isTimestamp = /^\d+$/.test(submissionDate);
  const days = submissionDate && !isTimestamp && (0,esm/* formatDateDistance */.jL)(new Date(submissionDate), new Date());
  const subtitle = (attributes == null ? void 0 : attributes.map((el, index) => index === 0 ? `${el.label}: ${el.value}` : ` | ${el.label}: ${el.value}`)) || [];
  const arrayImages = formatMediaList(product == null ? void 0 : product.images, 'image');
  const arrayVideos = formatMediaList(product == null ? void 0 : product.videos, 'video');
  const processedMedias = arrayImages.filter(elem => elem.processed).concat(arrayVideos.filter(elem => elem.processed));
  const thumbnailsMedias = arrayImages.filter(elem => elem.thumbnails).concat(arrayVideos.filter(elem => elem.thumbnails));

  const openPopup = name => {
    const mediaId = processedMedias.findIndex(elem => elem.mediaUrl.includes(name.split('.')[0]));
    setSelectedMedia(mediaId > 0 ? mediaId : 0);
    setIsPopupOpen(true);
  };

  return /*#__PURE__*/react.createElement(Box/* default */.Z, null, /*#__PURE__*/react.createElement(Header, null, /*#__PURE__*/react.createElement(Avatar/* default */.Z, null), /*#__PURE__*/react.createElement(ReviewerName, null, userData == null ? void 0 : userData.name), /*#__PURE__*/react.createElement(ReviewWrapper, null, /*#__PURE__*/react.createElement(Review/* default */.Z, {
    score: rating
  }))), subtitle.length > 0 && /*#__PURE__*/react.createElement(SubTitle, {
    "data-testid": "review-sub-title"
  }, subtitle), description && /*#__PURE__*/react.createElement(Description, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : `${description.substring(0, charLimit)}...`, "\xA0", !isShortDescription && /*#__PURE__*/react.createElement(SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    "data-testid": "see-more-btn",
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos')), days && /*#__PURE__*/react.createElement(DateWrapper, {
    "data-testid": "review-date"
  }, `há ${days}`), thumbnailsMedias.length > 0 && /*#__PURE__*/react.createElement(organisms/* ProductReviewGallery */.zT, null, renderGallery(thumbnailsMedias, openPopup)), isPopupOpen && /*#__PURE__*/react.createElement(organisms/* ProductReviewPopup */.Qp, {
    review: review,
    charLimit: charLimit,
    mediaProps: arrayImages.concat(arrayVideos),
    selectedMedia: selectedMedia,
    closePopup: () => setIsPopupOpen(false)
  }));
};

 false ? 0 : void 0;
OpinionSnippetBlock.defaultProps = {
  charLimit: 110,
  mediaReview: null
};
/* harmony default export */ var opinion_snippet_block = (OpinionSnippetBlock);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/index.js


/***/ }),

/***/ 1939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shipping_tags; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var esm = __webpack_require__(71180);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.styles.js



const ProductShippingCost = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(() => ({
  fontSize: 0,
  fontWeight: 'regular',
  marginTop: 1
}))`
  color: ${(0,build_esm/* getTextColor */.uu)('scratched')};
`;
const Container = styled_components_browser_esm/* default.div */.ZP.div``;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/product-card.styles.js
var product_card_styles = __webpack_require__(57862);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js + 2 modules
var TagInternational = __webpack_require__(37215);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.js









const ProductCardShippingTag = ({
  showShippingTags,
  shippingTag,
  price
}) => {
  const {
    time,
    cost,
    complement
  } = shippingTag;
  const showTagInternational = (0,utils/* isInternationalPrice */.xx)(price);
  const costDescription = cost === 0 ? 'Frete grátis' : `Frete: ${(0,esm/* currencyFormatter */.oB)({
    value: cost
  })}`;

  const ShippingCost = () => {
    return cost === 0 ? /*#__PURE__*/react.createElement(product_card_styles/* ShippingDescription */.dO, null, costDescription) : /*#__PURE__*/react.createElement(ProductShippingCost, null, costDescription);
  };

  return /*#__PURE__*/react.createElement(Box/* default */.Z, {
    marginTop: 1
  }, showTagInternational && /*#__PURE__*/react.createElement(TagInternational/* default */.Z, null), showShippingTags && /*#__PURE__*/react.createElement(Container, {
    "data-testid": "productCard-shipping-tag"
  }, cost !== null && cost !== undefined && /*#__PURE__*/react.createElement(ShippingCost, null), time && /*#__PURE__*/react.createElement(product_card_styles/* ShippingDescription */.dO, null, time), complement && /*#__PURE__*/react.createElement(product_card_styles/* ShippingDescription */.dO, null, complement)));
};

 false ? 0 : void 0;
ProductCardShippingTag.defaultProps = {
  showShippingTags: false,
  shippingTag: {},
  price: {}
};
/* harmony default export */ var shipping_tags = (ProductCardShippingTag);

/***/ }),

/***/ 43125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_card; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/product-card.styles.js
var product_card_styles = __webpack_require__(57862);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CardHeader/card-header.styles.js





const HeaderEl = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj)`
  grid-template-columns: 1fr ${({
  displayMode,
  sponsored,
  isMagaluIndica
}) => displayMode !== constants/* LIST */.IY && isMagaluIndica || displayMode === constants/* MINIATURE */.Co && sponsored ? '20px' : ''};
  margin-bottom: ${(0,build_esm/* themeGet */.R)('space.1')}px;
  ${props => props.displayMode === constants/* LIST */.IY && `
    grid-column-start: 3;
    grid-row-start: 1;
    align-self: start;
  `}
`;
const MagaluIndica = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Chip */.Af).attrs(props => Object.assign({}, props))`
  justify-self: start;
`;
const WishlistBtn = (0,styled_components_browser_esm/* default */.ZP)(molecules/* AddWishlistButton */.iG).attrs(props => Object.assign({
  width: 20,
  height: 20
}, props))`
  justify-self: end;
  max-width: 20px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CardHeader/card-header.js







const CardHeader = ({
  displayMode,
  sponsored,
  showWishBtn,
  isLiked,
  handleAddToWishlist,
  isMagaluIndica,
  isMercadoFull
}) => /*#__PURE__*/react.createElement(HeaderEl, {
  isMagaluIndica: isMagaluIndica || isMercadoFull,
  displayMode: displayMode,
  sponsored: sponsored
}, sponsored && displayMode === constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(product_card_styles/* SponsoredEl */.lK, {
  place: "header"
}, "Patrocinado"), (isMagaluIndica || isMercadoFull) && displayMode === constants/* GALLERY */.yg && /*#__PURE__*/react.createElement(MagaluIndica, {
  autoSize: true,
  padding: "2px 8px",
  bg: "primary",
  fontSize: 1,
  startIcon: isMagaluIndica ? /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "FastDelivery",
    fill: "#fff",
    width: "16px",
    height: "16px"
  }) : /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "FastMarket",
    fill: "#fff",
    width: "16px",
    height: "16px"
  }),
  fontWeight: "bold",
  gridGap: 1,
  minWidth: "unset",
  borderRadius: 6
}, isMagaluIndica ? 'Full' : 'Mercado Full'), showWishBtn && /*#__PURE__*/react.createElement(WishlistBtn, {
  active: isLiked,
  onClick: handleAddToWishlist
}));

 false ? 0 : void 0;
/* harmony default export */ var card_header = (CardHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/CardHeader/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/GeoLocTags/geoloc-tags.js







const ProductCardGeoLocTags = ({
  geoLocTags,
  displayMode
}) => {
  return geoLocTags != null && geoLocTags.title ? /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    justifyContent: displayMode === constants/* MINIATURE */.Co ? 'center' : null,
    gap: 1
  }, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: geoLocTags.icon || 'FastDelivery',
    color: "text.primary",
    width: 30,
    height: 30
  })), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    color: "text.primary",
    fontSize: [1, 1, 2, 2],
    fontWeight: "medium"
  }, geoLocTags.title))) : null;
};

 false ? 0 : void 0;
/* harmony default export */ var geoloc_tags = (ProductCardGeoLocTags);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/GeoLocTags/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ReviewVariations/review-variations.styles.js

const reviewGroupVariation = {
  miniature: styled_components_browser_esm/* css */.iv`
    justify-self: center;
    align-self: center;
  `,
  list: styled_components_browser_esm/* css */.iv`
    justify-self: left;
  `
};
const ReviewGroup = styled_components_browser_esm/* default.div */.ZP.div`
  ${({
  displayMode
}) => displayMode && reviewGroupVariation[displayMode]};
  max-height: 20px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ReviewVariations/review-variations.js




const renderReviewVariations = ({
  displayMode,
  count,
  score,
  allowEmptyRating,
  showRating,
  format
}) => {
  const shouldHideRating = !allowEmptyRating && !score;

  if (shouldHideRating || !showRating) {
    return null;
  }

  return /*#__PURE__*/react.createElement(ReviewGroup, {
    displayMode: displayMode
  }, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    format: format,
    score: score,
    count: count,
    width: "12px",
    height: "12px"
  }));
};

/* harmony default export */ var review_variations = (renderReviewVariations);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ReviewVariations/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/AllGeoLocTags/all-geoloc-tags.js





const ProductCardAllGeoLocTags = ({
  allGeoLocTags,
  displayMode
}) => {
  return allGeoLocTags.length > 0 && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    display: "none",
    "data-testid": "allGeoLocTags",
    flexDirection: "column"
  }, allGeoLocTags.map((geoLocTag, index) => {
    return geoLocTag.title && /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      key: index,
      alignItems: "center",
      display: displayMode === constants/* MINIATURE */.Co ? 'none' : null,
      color: "text.primary",
      fontSize: "0",
      fontWeight: "medium"
    }, geoLocTag.title);
  }));
};

 false ? 0 : void 0;
ProductCardAllGeoLocTags.defaultProps = {
  allGeoLocTags: []
};
/* harmony default export */ var all_geoloc_tags = (ProductCardAllGeoLocTags);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/AllGeoLocTags/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.js + 1 modules
var shipping_tags = __webpack_require__(1939);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/index.js + 2 modules
var LoyaltyCommission = __webpack_require__(99075);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/Loyalty/loyalty.js






const loyaltyComponent = {
  sales_commission: LoyaltyCommission/* default */.Z,
  sales_dynamic_commission: LoyaltyCommission/* default */.Z
};

const Loyalty = ({
  displayMode,
  loyalty,
  productUrl
}) => {
  const LoyaltyComponent = loyaltyComponent[loyalty == null ? void 0 : loyalty.type];
  if (!loyalty) return null;
  return /*#__PURE__*/react.createElement(product_card_styles/* LoyaltyContainer */.RJ, {
    displayMode: displayMode
  }, LoyaltyComponent && /*#__PURE__*/react.createElement(LoyaltyComponent, (0,esm_extends/* default */.Z)({}, loyalty, {
    productUrl: productUrl
  })));
};

Loyalty.defaultProps = {
  displayMode: constants/* LIST */.IY,
  loyalty: {},
  productUrl: ''
};
 false ? 0 : void 0;
/* harmony default export */ var Loyalty_loyalty = (Loyalty);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/Loyalty/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/index.js + 2 modules
var ProductCardPrice = __webpack_require__(12795);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/product-card.js



















const parseUrl = ({
  domain,
  url,
  adsSellerId
}) => {
  const isFullURL = /^https?:\/\//.test(url);
  const productUrl = new URL(isFullURL ? url : domain + url);

  if (adsSellerId) {
    productUrl.searchParams.append('seller_id', adsSellerId);
  }

  const absoluteUrl = productUrl.toString();
  const href = isFullURL ? absoluteUrl : absoluteUrl.replace(productUrl.origin, '');
  return {
    absoluteUrl,
    href
  };
};

const ProductCard = _ref => {
  let {
    hideLinkBorder,
    onClick,
    onMouseDown,
    onView,
    domain,
    imgLazyLoading,
    index,
    lazyLoadingOffset,
    showInCashInfo,
    enableShadow,
    enableHover,
    geoLocTags,
    allGeoLocTags,
    hidePriceMode,
    hidePrice,
    hidePriceButtonAction,
    showPreview,
    previewAction,
    showWishBtn,
    onClickWishBtn,
    fullHeight,
    showRating,
    showDiscount,
    showDiscountOnlyCashInfo,
    allowEmptyRating,
    containerWidth,
    onThumbnailClick,
    colorMinLength,
    attributeStyle,
    offerTimerProps
  } = _ref,
      product = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["adId", "hideLinkBorder", "onClick", "onMouseDown", "onView", "domain", "imgLazyLoading", "index", "lazyLoadingOffset", "showInCashInfo", "enableShadow", "enableHover", "geoLocTags", "allGeoLocTags", "hidePriceMode", "hidePrice", "hidePriceButtonAction", "showPreview", "previewAction", "showWishBtn", "onClickWishBtn", "fullHeight", "showRating", "percentBadge", "showDiscount", "showDiscountOnlyCashInfo", "allowEmptyRating", "containerWidth", "onThumbnailClick", "colorMinLength", "attributeStyle", "offerTimerProps"]);

  const {
    displayMode,
    title,
    price,
    image,
    installment,
    badges,
    rating,
    variationId,
    url,
    titleAs,
    loyalty,
    imageAltPrefix,
    isOnWishlist,
    imageWidth,
    imageHeight,
    shippingCost,
    shippingTag,
    brand,
    offerTags,
    ads,
    adsSellerId,
    thumbnails,
    restrictions,
    parsedAttributes,
    reward,
    tagCoupon
  } = product;
  const {
    absoluteUrl,
    href
  } = parseUrl({
    domain,
    url,
    adsSellerId
  });
  const {
    count,
    score
  } = rating;
  const isMagaluIndica = offerTags == null ? void 0 : offerTags.includes('magalu_indica');
  const isMercadoFull = offerTags == null ? void 0 : offerTags.includes('mercado_full');
  const badge = badges == null ? void 0 : badges.slice(-1)[0];

  const handleAddToWishlist = e => {
    e.stopPropagation();
    e.preventDefault();
    onClickWishBtn(e);
  };

  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0.5,
    delay: 1000
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onView(Object.assign({
        index,
        geoLocTags
      }, product));
    }
  }, [inView]);
  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${product.title}` : product.title;
  const adIdValidated = (ads == null ? void 0 : ads.id) || undefined;
  const priceData = {
    hide: hidePriceMode === 'hide',
    hiddenPrice: hidePrice,
    displayMode,
    installment,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    price,
    hidePriceButtonAction,
    product
  };
  const defaultTagProps = {
    autoSize: true,
    bg: 'primary',
    borderRadius: 6,
    fontSize: 1,
    fontWeight: 'medium',
    gridGap: 1,
    mb: 1,
    minWidth: 'unset',
    padding: '2px 8px'
  };
  return /*#__PURE__*/react.createElement(product_card_styles/* Container */.W2, {
    ref: ref,
    href: href,
    onClick: e => onClick(e, Object.assign({}, product, {
      index
    })),
    onMouseDown: e => onMouseDown(e, Object.assign({}, product, {
      index
    })),
    displayMode: displayMode,
    "data-testid": "product-card-container",
    "ads-click-event": adIdValidated,
    "ads-view-event": adIdValidated,
    "ads-impression-event": adIdValidated,
    redirect: href,
    hideLinkBorder: hideLinkBorder,
    enableShadow: enableShadow,
    enableHover: enableHover,
    fullHeight: fullHeight,
    containerWidth: containerWidth,
    index: index,
    "data-brand": brand == null ? void 0 : brand.slug
  }, /*#__PURE__*/react.createElement(card_header, {
    displayMode: displayMode,
    sponsored: ads == null ? void 0 : ads.sponsored,
    showWishBtn: showWishBtn,
    isLiked: isOnWishlist,
    handleAddToWishlist: handleAddToWishlist,
    isMagaluIndica: isMagaluIndica,
    isMercadoFull: isMercadoFull
  }), /*#__PURE__*/react.createElement(product_card_styles/* ImageContainer */.mo, {
    displayMode: displayMode
  }, displayMode === constants/* LIST */.IY && /*#__PURE__*/react.createElement(react.Fragment, null, isMagaluIndica && /*#__PURE__*/react.createElement(product_card_styles/* MagaluIndica */.Tl, (0,esm_extends/* default */.Z)({}, defaultTagProps, {
    startIcon: /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: "FastDelivery",
      fill: "#fff",
      width: "16px",
      height: "16px"
    })
  }), "Full"), isMercadoFull && /*#__PURE__*/react.createElement(product_card_styles/* MercadoFull */.Lq, (0,esm_extends/* default */.Z)({}, defaultTagProps, {
    startIcon: /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: "FastMarket",
      fill: "#fff",
      width: "16px",
      height: "16px"
    })
  }), "Mercado Full")), /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    src: image,
    alt: imageAlt,
    width: imageWidth,
    height: imageHeight,
    title: title,
    lazy: imgLazyLoading,
    offset: lazyLoadingOffset,
    mb: 1
  }), /*#__PURE__*/react.createElement(Loyalty_loyalty, {
    displayMode: displayMode,
    loyalty: loyalty,
    productUrl: absoluteUrl
  }), !!badge && /*#__PURE__*/react.createElement(molecules/* Badge */.Ct, {
    key: `${variationId}-badge-${badge.id}`,
    url: badge.imageUrl,
    tooltip: badge.tooltip,
    displayMode: displayMode,
    borderRadius: "medium"
  }), displayMode === constants/* LIST */.IY && parsedAttributes && /*#__PURE__*/react.createElement(organisms/* AttributeList */.dO, {
    attributes: parsedAttributes,
    variations: thumbnails,
    colorVariant: "button",
    showTitle: false,
    colorMinLength: colorMinLength,
    gap: 1,
    style: attributeStyle,
    onVariationClick: onThumbnailClick
  })), showPreview && /*#__PURE__*/react.createElement(product_card_styles/* ButtonPreviewContainer */.Mn, {
    "data-testid": "button-preview-container"
  }, /*#__PURE__*/react.createElement(product_card_styles/* ButtonPreview */.AH, {
    size: "small",
    m: '10px 0',
    "data-testid": "button-preview",
    onClick: e => {
      e.preventDefault();
      previewAction(product);
    }
  }, "Conferir")), /*#__PURE__*/react.createElement(product_card_styles/* Content */.VY, {
    displayMode: displayMode,
    "data-testid": "product-card-content"
  }, displayMode !== constants/* LIST */.IY && parsedAttributes && /*#__PURE__*/react.createElement(organisms/* AttributeList */.dO, {
    attributes: parsedAttributes,
    variations: thumbnails,
    onVariationClick: onThumbnailClick,
    colorVariant: "button",
    showTitle: false,
    gap: 1,
    colorMinLength: colorMinLength,
    style: attributeStyle
  }), displayMode !== constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(molecules/* OfferTimer */.dV, (0,esm_extends/* default */.Z)({
    height: 20,
    fontSize: ['10px', 1],
    restrictions: restrictions,
    displayMode: displayMode
  }, offerTimerProps)), (ads == null ? void 0 : ads.sponsored) && displayMode !== constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(product_card_styles/* SponsoredEl */.lK, {
    place: "content"
  }, "Patrocinado"), displayMode !== constants/* MINIATURE */.Co && /*#__PURE__*/react.createElement(product_card_styles/* Title */.Dx, {
    as: titleAs,
    displayMode: displayMode,
    "data-testid": "product-title"
  }, title), review_variations({
    displayMode,
    count,
    score,
    allowEmptyRating,
    showRating,
    format: 'score-count'
  }), /*#__PURE__*/react.createElement(geoloc_tags, {
    geoLocTags: geoLocTags,
    displayMode: displayMode
  }), /*#__PURE__*/react.createElement(ProductCardPrice/* default */.Z, priceData), /*#__PURE__*/react.createElement(molecules/* TagCoupon */.rE, {
    mt: 1,
    tags: tagCoupon
  }), /*#__PURE__*/react.createElement(molecules/* ProductShipping */.lF, {
    displayMode: displayMode,
    costDescription: shippingCost.costDescription,
    cost: shippingCost.cost
  }), /*#__PURE__*/react.createElement(all_geoloc_tags, {
    allGeoLocTags: allGeoLocTags,
    displayMode: displayMode
  }), /*#__PURE__*/react.createElement(shipping_tags/* default */.Z, {
    showShippingTags: displayMode !== constants/* MINIATURE */.Co,
    shippingTag: shippingTag,
    price: price
  }), !!reward && !!(reward != null && reward.active) && /*#__PURE__*/react.createElement(molecules/* AlertText */.QP, {
    icon: reward == null ? void 0 : reward.icon,
    message: reward == null ? void 0 : reward.message,
    intent: reward == null ? void 0 : reward.intent,
    styleContainer: reward == null ? void 0 : reward.styleContainer,
    styleMessage: reward == null ? void 0 : reward.styleMessage
  })));
};

/* harmony default export */ var product_card = (ProductCard);
 false ? 0 : void 0;
ProductCard.defaultProps = {
  variationId: '',
  url: '',
  displayMode: constants/* LIST */.IY,
  domain: constants/* MAGALU_DOMAIN */.RW,
  title: '',
  image: '',
  index: 0,
  price: {},
  installment: {},
  geoLocTags: {},
  allGeoLocTags: [],
  rating: {},
  badges: [],
  brand: {},
  onClick: () => {},
  onMouseDown: () => {},
  onView: () => {},
  imgLazyLoading: false,
  fullHeight: false,
  percentBadge: 30,
  lazyLoadingOffset: 50,
  showInCashInfo: true,
  hideLinkBorder: false,
  titleAs: 'h2',
  enableShadow: true,
  enableHover: false,
  imageAltPrefix: '',
  hidePriceMode: 'blur',
  hidePrice: false,
  hidePriceButtonAction: null,
  showPreview: false,
  previewAction: () => {},
  isOnWishlist: false,
  showWishBtn: false,
  onClickWishBtn: () => {},
  showRating: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: true,
  shippingCost: {},
  ads: {},
  shippingTag: {},
  allowEmptyRating: false,
  onThumbnailClick: null,
  colorMinLength: 3,
  attributeStyle: {
    width: '42px',
    height: '42px',
    bg: 'background.lighter',
    color: 'background.primary',
    shouldHover: true
  },
  offerTimerProps: {}
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js


/***/ }),

/***/ 57862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ ButtonPreview; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Lq": function() { return /* binding */ MercadoFull; },
/* harmony export */   "Mn": function() { return /* binding */ ButtonPreviewContainer; },
/* harmony export */   "RJ": function() { return /* binding */ LoyaltyContainer; },
/* harmony export */   "Tl": function() { return /* binding */ MagaluIndica; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "dO": function() { return /* binding */ ShippingDescription; },
/* harmony export */   "lK": function() { return /* binding */ SponsoredEl; },
/* harmony export */   "mo": function() { return /* binding */ ImageContainer; }
/* harmony export */ });
/* unused harmony export WishlistBtn */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99673);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68054);
/* harmony import */ var _magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55403);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39146);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12468);
/* harmony import */ var _atoms_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27439);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87043);








const getContainer = (displayMode, containerWidth) => {
  const sizes = {
    miniature: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
      display: grid;
      padding: 8px 2px;
    `,
    list: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
      display: grid;
      grid-template-columns: 1.5fr 2fr;
      ${containerWidth >= 500 && styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
        ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getMediaQuery */ .aK)('small')} {
          grid-template-columns: 180px 2fr;
          grid-column-gap: 20px;
        }
      `}
      padding: 16px;
    `,
    gallery: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
      grid-template-rows: auto auto 1fr;
    `
  };
  return sizes[displayMode];
};

const SponsoredEl = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv).attrs(props => Object.assign({
  fontSize: 13,
  fontWeight: 'regular',
  lineHeight: 'display'
}, props))`
  justify-self: left;
  color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getTextColor */ .uu)('light')};

  ${styled_system__WEBPACK_IMPORTED_MODULE_0__/* .typography */ .cp}
`;
const WishlistBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_molecules__WEBPACK_IMPORTED_MODULE_2__/* .AddWishlistButton */ .iG).attrs(props => Object.assign({
  width: 20,
  height: 20
}, props))`
  justify-self: end;
  max-width: 20px;
`;
const Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_atoms_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)`
  position: relative;
  padding: 10px;
  justify-content: unset;
  background-color: ${props => props.hideLinkBorder ? 'unset' : (0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getPaletteColor */ .ow)('background.lighter')(props)};
  ${({
  displayMode,
  containerWidth
}) => displayMode && getContainer(displayMode, containerWidth)};
  display: grid;

  ${({
  fullHeight
}) => fullHeight && `
    display: flex;
    flex-direction: column;
    height: 100%;
  `}
`;
const imgContainerDisplay = {
  miniature: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
    height: 20vw;
    justify-content: flex-end;
    ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getMediaQuery */ .aK)('small')} {
      height: 120px;
    }
  `,
  list: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
    justify-content: flex-start;
    padding-top: 4px;
    min-height: 25vw;
    & > img {
      max-height: 160px;
    }
    ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getMediaQuery */ .aK)('small')} {
      min-height: initial;
      max-height: 210px;
    }
  `,
  gallery: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
    height: 32vw;
    justify-content: flex-end;
    ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getMediaQuery */ .aK)('small')} {
      max-height: 210px;
    }
  `
}; // "& > .lazyload-wrapper" stylizes the image's <LazyLoad> container

const ImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .ZP.div`
  position: relative;
  display: flex;
  flex-direction: column;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
  ${({
  displayMode
}) => displayMode && imgContainerDisplay[displayMode]}
`;
const LoyaltyContainerDisplay = {
  miniature: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
    justify-content: center;
  `,
  list: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
    justify-content: flex-start;
  `,
  gallery: styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv`
    justify-content: flex-end;
  `
};
const LoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .ZP.div`
  position: absolute;
  display: flex;
  width: 100%;
  top: 5%;
  ${({
  displayMode
}) => displayMode && LoyaltyContainerDisplay[displayMode]}
`;
const Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv).attrs(props => Object.assign({
  fontSize: [1, 1, 1],
  lineHeight: 'display',
  fontWeight: 'regular'
}, props))`
  ${({
  displayMode
}) => displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY ? `height: 52px;` : `height: 32px;`};
  color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getTextColor */ .uu)('base')};
  -webkit-line-clamp: ${({
  displayMode
}) => displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY ? 3 : 2};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
  margin: 4px 0 4px 0;
  ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getMediaQuery */ .aK)('small')} {
    ${({
  displayMode
}) => displayMode === _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY && `height: 40px;`};
  }
  ${styled_system__WEBPACK_IMPORTED_MODULE_0__/* .typography */ .cp}
`;
const Content = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .ZP.div`
  ${({
  displayMode
}) => displayMode === _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY && `padding-left: 8px`}
  ${({
  displayMode
}) => displayMode !== _constants__WEBPACK_IMPORTED_MODULE_3__/* .LIST */ .IY && `
    display: grid;
    padding-top: 8px;
  `}
`;
const ButtonPreviewContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .ZP.div`
  width: 100%;
  height: 15px;
  position: relative;
`;
const ButtonPreview = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx)`
  opacity: 0.7;
  visibility: hidden;
  position: absolute;
  width: 50%;
  min-width: 90px;

  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;

  &:hover {
    opacity: 1;
  }

  /* stylelint-disable-next-line selector-type-no-unknown */
  ${Container}:hover & {
    visibility: visible;
  }
`;
const MagaluIndica = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Chip */ .Af).attrs(props => Object.assign({}, props))`
  width: 66px;
`;
const MercadoFull = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Chip */ .Af).attrs(props => Object.assign({}, props))`
  width: 126px;
`;
const ShippingDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv).attrs(() => ({
  fontSize: 0,
  fontWeight: 'medium',
  marginTop: 1
}))`
  color: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* .getTextColor */ .uu)('primary')};
`;

/***/ }),

/***/ 3018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_card_horizontal; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/OfferTimer/index.js + 2 modules
var OfferTimer = __webpack_require__(3310);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/TagCoupon/index.js + 2 modules
var TagCoupon = __webpack_require__(62458);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/product-card-horizontal.styles.js
// codegen: this was automatically generated




const Container = styled_components_browser_esm/* default.a */.ZP.a`
  display: flex;
  cursor: pointer;
  padding: 16px;
  border-radius: 12px;
  height: 100%;
  background-color: #fff;
  max-width: 560px;
  text-decoration: none;
  ${({
  showBorder
}) => showBorder && styled_components_browser_esm/* css */.iv`
      &,
      &:active,
      &:focus,
      &:hover {
        border: solid 1px ${(0,esm/* getBackgroundColor */.dF)('primary')};
      }
    `}
`;
const ImageContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  flex-direction: column;
  flex-basis: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  & > img {
    max-width: 100%;
    max-height: 100%;
  }
`;
const Content = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Flex */.kC)`
  padding-left: 12px;
  flex-basis: 70%;
  flex-direction: column;
  justify-content: center;
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(props => Object.assign({
  fontSize: [1, 1, 1],
  lineHeight: 'big',
  fontWeight: 'regular'
}, props))`
  max-height: 44px;
  color: ${(0,esm/* getTextColor */.uu)('base')};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
  ${(0,esm/* getMediaQuery */.aK)('small')} {
    max-height: 44px;
  }
  ${index_esm/* typography */.cp}
`;
const CardButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx).attrs(props => Object.assign({}, props))`
  background-color: #4ea900;
  border-radius: 8px;
  margin-top: 12px;
  max-width: 264px;
  height: 40px;

  ${({
  empty
}) => empty && `
    pointer-events: none;
  `}
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/ShippingTags/shipping-tags.js + 1 modules
var shipping_tags = __webpack_require__(1939);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/index.js + 2 modules
var ProductCardPrice = __webpack_require__(12795);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/product-card-horizontal.js












function ProductCardHorizontal(_ref) {
  let {
    imgLazyLoading,
    showInCashInfo,
    showDiscount,
    showOfferTimer,
    onView,
    index,
    onClick,
    onMouseDown,
    showDiscountOnlyCashInfo,
    lazyLoadingOffset,
    hidePriceButtonAction,
    showBorder,
    restrictions,
    buttonProps,
    showButton,
    hideOriginalPrice
  } = _ref,
      product = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["imgLazyLoading", "showInCashInfo", "showDiscount", "showOfferTimer", "onView", "index", "geoLocTags", "onClick", "onMouseDown", "showDiscountOnlyCashInfo", "lazyLoadingOffset", "hidePriceButtonAction", "showBorder", "restrictions", "buttonProps", "showButton", "hideOriginalPrice"]);

  const {
    title,
    price,
    image,
    installment,
    url,
    titleAs,
    shippingTag,
    imageWidth,
    imageHeight,
    imageAltPrefix,
    hidePrice,
    tagCoupon
  } = product;
  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${product.title}` : product.title;
  const displayMode = 'list';
  const hasRestrictions = Boolean((restrictions == null ? void 0 : restrictions.timer_start_date) && (restrictions == null ? void 0 : restrictions.timer_end_date));
  const hasCoupon = Boolean(tagCoupon && (tagCoupon == null ? void 0 : tagCoupon.discountValue));
  const [ref, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold: 0.5,
    delay: 1000
  });
  (0,react.useEffect)(() => {
    if (inView) {
      onView(Object.assign({
        index
      }, product));
    }
  }, [inView]);
  const priceData = {
    hiddenPrice: hidePrice,
    displayMode,
    installment,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    price,
    hidePriceButtonAction,
    hideOriginalPrice,
    product
  };
  const hasInstallment = !!(installment != null && installment.amount && installment != null && installment.totalAmount && (installment == null ? void 0 : installment.quantity) > 1);
  return /*#__PURE__*/react.createElement(Container, {
    ref: ref,
    href: url,
    index: index,
    onClick: e => onClick(e, Object.assign({}, product, {
      index
    })),
    onMouseDown: e => onMouseDown(e, Object.assign({}, product, {
      index
    })),
    "data-testid": "product-card-horizontal",
    showBorder: showBorder
  }, /*#__PURE__*/react.createElement(ImageContainer, {
    width: imageWidth,
    height: imageHeight
  }, /*#__PURE__*/react.createElement(atoms/* Image */.Ee, {
    src: image,
    alt: imageAlt,
    width: imageWidth,
    height: imageHeight,
    title: title,
    lazy: imgLazyLoading,
    offset: lazyLoadingOffset
  })), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    "data-testid": "product-title"
  }, title), showOfferTimer && hasRestrictions && !hasCoupon && /*#__PURE__*/react.createElement(OfferTimer/* default */.Z, {
    mt: 1,
    mr: 0,
    mb: 0,
    restrictions: {
      timer_start_date: restrictions == null ? void 0 : restrictions.timer_start_date,
      timer_end_date: restrictions == null ? void 0 : restrictions.timer_end_date
    },
    height: "20px",
    fontSize: "14px"
  }), /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    mt: hasInstallment ? 0 : 2
  }, /*#__PURE__*/react.createElement(ProductCardPrice/* default */.Z, priceData)), /*#__PURE__*/react.createElement(TagCoupon/* default */.Z, {
    mt: 1,
    tags: tagCoupon
  }), /*#__PURE__*/react.createElement(shipping_tags/* default */.Z, {
    showShippingTags: true,
    shippingTag: {
      cost: shippingTag == null ? void 0 : shippingTag.cost
    },
    price: price
  }), showButton && /*#__PURE__*/react.createElement(CardButton, (0,esm_extends/* default */.Z)({}, buttonProps, {
    empty: !(buttonProps != null && buttonProps.onClick),
    onClick: buttonProps == null ? void 0 : buttonProps.onClick,
    uppercase: false,
    "data-testid": "better-offer-btn"
  }), (buttonProps == null ? void 0 : buttonProps.title) || 'Ver oferta')));
}

 false ? 0 : void 0;
ProductCardHorizontal.defaultProps = {
  imgLazyLoading: false,
  showInCashInfo: true,
  showDiscount: false,
  url: '',
  onClick: () => {},
  onMouseDown: () => {},
  onView: () => {},
  geoLocTags: {},
  index: 0,
  showDiscountOnlyCashInfo: true,
  lazyLoadingOffset: 50,
  hidePriceButtonAction: () => {},
  showBorder: false,
  restrictions: {
    timer_end_date: prop_types.string,
    timer_start_date: prop_types.string
  },
  showButton: false,
  hideOriginalPrice: false
};
/* harmony default export */ var product_card_horizontal = (ProductCardHorizontal);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/index.js


/***/ }),

/***/ 12795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_card_price; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/product-card-price.styles.js


const HiddenPriceContainer = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;

  span {
    filter: blur(3px);
  }
`;
const ShowPriceButton = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Button */.zx)`
  visibility: hidden;
  position: absolute;
  bottom: 0;

  /* stylelint-disable-next-line selector-type-no-unknown */
  ${HiddenPriceContainer}:hover & {
    visibility: visible;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/product-card-price.js







const ProductCardPrice = ({
  hide,
  hiddenPrice,
  displayMode,
  installment,
  showInCashInfo,
  showDiscount,
  showDiscountOnlyCashInfo,
  price,
  hidePriceButtonAction,
  hideOriginalPrice,
  product
}) => {
  if (hide) {
    return null;
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, !hiddenPrice && /*#__PURE__*/react.createElement(molecules/* Price */.tA, (0,esm_extends/* default */.Z)({
    style: {
      mt: '0px'
    },
    display: displayMode,
    installment: installment,
    showInCashInfo: showInCashInfo,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    hideOriginalPrice: hideOriginalPrice
  }, price)), hiddenPrice && /*#__PURE__*/react.createElement(HiddenPriceContainer, null, /*#__PURE__*/react.createElement("span", {
    "data-testid": "hided-price"
  }, /*#__PURE__*/react.createElement(molecules/* Price */.tA, {
    style: {
      mt: '0px'
    },
    display: displayMode,
    installment: null,
    price: 0.0,
    showInCashInfo: showInCashInfo
  })), hidePriceButtonAction && /*#__PURE__*/react.createElement(ShowPriceButton, {
    full: true,
    size: "small",
    m: '10px 0',
    "data-testid": "show-price-button",
    onClick: e => {
      e.preventDefault();
      hidePriceButtonAction(product);
    }
  }, "Ver Pre\xE7o")));
};

/* harmony default export */ var product_card_price = (ProductCardPrice);
 false ? 0 : void 0;
ProductCardPrice.defaultProps = {
  hide: false,
  hiddenPrice: false,
  displayMode: constants/* LIST */.IY,
  installment: {},
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: true,
  price: {},
  hidePriceButtonAction: null,
  product: {},
  hideOriginalPrice: false
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardPrice/index.js


/***/ }),

/***/ 4720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 13 modules
var ProductCard = __webpack_require__(43125);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/index.js + 2 modules
var ProductCardHorizontal = __webpack_require__(3018);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/product-carousel.js






function ProductCarousel({
  products,
  displayMode,
  onClick,
  onMouseDown,
  onProductView,
  onChange,
  gutter,
  showInCashInfo,
  slidesPerView,
  interval,
  auto,
  showPartialNextSlide,
  transitionDuration,
  productTitleAs,
  imageAltPrefix,
  imgLazyLoading,
  imageWidth,
  imageHeight,
  showControls,
  showArrowControls,
  showRating,
  enableHover,
  showPreview,
  showDiscount,
  showOfferTimer,
  showDiscountOnlyCashInfo,
  fullHeight,
  previewAction,
  cardType,
  offerTimerProps,
  showBorder,
  showButton,
  buttonProps,
  hideOriginalPrice
}) {
  const handleCarouselChange = active => {
    const actives = Array(slidesPerView).fill().map((_, index) => products[index + active]);
    onChange(actives);
  };

  const showArrowControlsProp = showArrowControls && slidesPerView <= (products == null ? void 0 : products.length);
  const variations = {
    horizontal: ProductCardHorizontal/* default */.Z,
    vertical: ProductCard/* default */.Z
  };
  const Card = variations[cardType];
  return /*#__PURE__*/react.createElement(molecules/* Carousel */.lr, {
    onChange: handleCarouselChange,
    slidesPerView: slidesPerView,
    gutter: gutter,
    auto: auto,
    interval: interval,
    showPartialNextSlide: showPartialNextSlide,
    transitionDuration: transitionDuration,
    isProductCarousel: true,
    showControls: showControls,
    showArrowControls: showArrowControlsProp
  }, products == null ? void 0 : products.map((product, index) => /*#__PURE__*/react.createElement(Card, (0,esm_extends/* default */.Z)({}, product, {
    displayMode: displayMode,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onView: onProductView,
    showInCashInfo: showInCashInfo,
    titleAs: productTitleAs,
    fullHeight: fullHeight,
    imageAltPrefix: imageAltPrefix,
    imgLazyLoading: imgLazyLoading,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    showRating: showRating,
    showOfferTimer: showOfferTimer,
    key: `product-carousel-${product.variationId || product.id}-${index}`,
    enableHover: enableHover,
    showPreview: showPreview,
    previewAction: previewAction,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    offerTimerProps: offerTimerProps,
    showBorder: showBorder,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: hideOriginalPrice
  }))));
}
 false ? 0 : void 0;
ProductCarousel.defaultProps = {
  displayMode: 'gallery',
  onClick: () => {},
  onMouseDown: () => {},
  onProductView: () => {},
  onChange: () => {},
  showInCashInfo: true,
  showPartialNextSlide: true,
  auto: true,
  slidesPerView: 2,
  interval: 5000,
  fullHeight: true,
  transitionDuration: 400,
  gutter: 2,
  productTitleAs: 'h2',
  imageAltPrefix: '',
  imgLazyLoading: true,
  showControls: true,
  showArrowControls: false,
  showRating: true,
  enableHover: true,
  showPreview: false,
  showDiscount: false,
  showDiscountOnlyCashInfo: false,
  previewAction: () => {},
  cardType: 'vertical',
  showBorder: false,
  showOfferTimer: false,
  showButton: false,
  buttonProps: {},
  hideOriginalPrice: false
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js


/***/ }),

/***/ 98284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 13 modules
var ProductCard = __webpack_require__(43125);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/product-list.styles.js








const variations = ({
  displayMode
}) => {
  const containerStyle = {
    gallery: styled_components_browser_esm/* css */.iv`
      grid-template-columns: 1fr 1fr;
      ${(0,build_esm/* getMediaQuery */.aK)('small')} {
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
      }
    `,
    list: styled_components_browser_esm/* css */.iv`
      grid-template-columns: 1fr;
    `,
    miniature: styled_components_browser_esm/* css */.iv`
      grid-template-columns: 1fr 1fr 1fr;
      ${(0,build_esm/* getMediaQuery */.aK)('small')} {
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      }
    `
  };
  return containerStyle[displayMode];
};

const NotFound = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  fontSize: [1, 2, 2, 2],
  py: 3,
  px: 2,
  color: 'text.scratched',
  borderRadius: 'medium',
  bg: 'transparent',
  textAlign: ['center', 'left', 'left', 'left'],
  boxShadow: [4, 'none', 'none', 'none']
}, props))`
  min-width: 280px;
  margin: 0 auto;
  border-radius: 4px;
  transition: width 0.2s ease;
  word-break: break-word;

  ${index_esm/* shadow */.AF}
  ${build_esm/* color */.$_}
  ${index_esm/* space */.Dh}
  ${index_esm/* typography */.cp}
`;
const NotFoundTitle = styled_components_browser_esm/* default.h1.attrs */.ZP.h1.attrs(props => Object.assign({
  fontSize: [3, 5, 5, 5],
  fontWeight: 'regular'
}, props))`
  text-align: center;
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  line-height: normal;
  margin-bottom: 18px;
  span {
    color: ${props => (0,build_esm/* getPaletteColor */.ow)('primary.base')(props)};
    display: inline-flex;
    word-wrap: break-word;
    overflow: hidden;
    max-height: 2.4em;
    line-height: 1.2em;
  }

  ${(0,build_esm/* getMediaQuery */.aK)('small')} {
    text-align: left;
  }

  ${index_esm/* typography */.cp}
`;
const SearchIconWrapper = styled_components_browser_esm/* default.span.attrs */.ZP.span.attrs(() => ({
  mr: 3
}))`
  display: none;

  ${(0,build_esm/* getMediaQuery */.aK)('small')} {
    display: block;
  }

  ${index_esm/* space */.Dh}
`;
const SearchIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* Search */.olm).attrs(props => Object.assign({
  width: 60,
  height: 60,
  color: 'primary.base'
}, props))`
  ${build_esm/* color */.$_}
`;
const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(props => Object.assign({}, props))`
  margin: 0;
  overflow: hidden;
  transition: width 0.2s ease;
`;
const product_list_styles_List = (0,styled_components_browser_esm/* default */.ZP)(List/* default */.Z).attrs(props => Object.assign({
  gridGap: ['2px', '1px', '1px']
}, props))`
  ${({
  displayMode
}) => variations({
  displayMode
})}
  ${index_esm/* grid */.eC}
`;
const ListAction = (0,styled_components_browser_esm/* default */.ZP)(product_list_styles_List.Action).attrs(() => ({
  fontWeight: 'regular',
  color: 'background.primary',
  fill: 'background.primary'
}))`
  border-top: ${(0,build_esm/* themeGet */.R)('borders.0')};
`;
const ListItem = styled_components_browser_esm/* default.li */.ZP.li`
  list-style: none;
  > * {
    min-height: 100%;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/product-list-not-found.js




const ProductListNotFound = ({
  message,
  messageSecondary
}) => /*#__PURE__*/react.createElement(NotFound, {
  "data-testid": "product-list-empty"
}, /*#__PURE__*/react.createElement(SearchIconWrapper, null, /*#__PURE__*/react.createElement(SearchIcon, null)), /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(NotFoundTitle, null, message), messageSecondary || ''));

 false ? 0 : void 0;
ProductListNotFound.defaultProps = {
  messageSecondary: '',
  message: ''
};
/* harmony default export */ var product_list_not_found = (ProductListNotFound);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/index.js + 1 modules
var JsonLD = __webpack_require__(66228);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/product-list.js









const ProductList = /*#__PURE__*/(0,react.forwardRef)(function ProductList(_ref, ref) {
  var _ref2;

  let {
    hidePriceButtonAction,
    lazyLoadingOffset,
    onClickLoadMore,
    imgLazyLoading,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    imageAltPrefix,
    imageWidth,
    imageHeight,
    onClickWishBtn,
    previewAction,
    showFullListBtn,
    enableShadow,
    displayMode,
    enableHover,
    showPreview,
    showWishBtn,
    showMoreBtn,
    hidePrice,
    notFound,
    onClick,
    onMouseDown,
    onProductView,
    partial,
    titleAs,
    domain,
    jsonLD,
    allowEmptyRating,
    data,
    gridGap,
    onThumbnailClick,
    colorMinLength,
    attributeStyle,
    offerTimerProps
  } = _ref,
      rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["hidePriceButtonAction", "lazyLoadingOffset", "onClickLoadMore", "imgLazyLoading", "showInCashInfo", "showDiscount", "showDiscountOnlyCashInfo", "imageAltPrefix", "imageWidth", "imageHeight", "onClickWishBtn", "previewAction", "showFullListBtn", "enableShadow", "displayMode", "enableHover", "showPreview", "showWishBtn", "showMoreBtn", "hidePrice", "notFound", "onClick", "onMouseDown", "onProductView", "partial", "titleAs", "domain", "jsonLD", "allowEmptyRating", "data", "gridGap", "onThumbnailClick", "colorMinLength", "attributeStyle", "offerTimerProps"]);

  (_ref2 = ref) !== null && _ref2 !== void 0 ? _ref2 : ref = (0,react.useRef)(null);
  const [containerWidth, setContainerWidth] = (0,react.useState)(0);
  const [collapsed, setCollapsed] = (0,react.useState)(Boolean(partial));
  const props = partial && !showFullListBtn && {
    collapse: true,
    trigger: collapsed,
    collapsedIn: partial
  };
  react.useEffect(() => {
    var _ref3;

    if ((_ref3 = ref) != null && _ref3.current) {
      setContainerWidth(ref.current.clientWidth);
    }

    setCollapsed(Boolean(partial));
    return () => setCollapsed(false);
  }, [partial]);
  if (notFound) return /*#__PURE__*/react.createElement(product_list_not_found, notFound);
  const Products = data == null ? void 0 : data.map((item, index) => /*#__PURE__*/react.createElement(ListItem, {
    key: `product-item-${index}`
  }, /*#__PURE__*/react.createElement(ProductCard/* default */.Z, (0,esm_extends/* default */.Z)({
    key: `product-${item.variationId || item.id}-${index}`,
    hidePriceButtonAction: hidePriceButtonAction,
    lazyLoadingOffset: lazyLoadingOffset,
    imgLazyLoading: imgLazyLoading,
    showInCashInfo: showInCashInfo,
    imageAltPrefix: imageAltPrefix,
    imageWidth: imageWidth,
    imageHeight: imageHeight,
    enableShadow: enableShadow,
    displayMode: displayMode,
    domain: domain,
    enableHover: enableHover,
    showPreview: showPreview,
    showWishBtn: showWishBtn,
    hidePrice: hidePrice,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onView: onProductView,
    titleAs: titleAs,
    index: index,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    onClickWishBtn: e => onClickWishBtn(e, item),
    previewAction: () => previewAction(item),
    allowEmptyRating: allowEmptyRating,
    containerWidth: containerWidth,
    onThumbnailClick: onThumbnailClick,
    colorMinLength: colorMinLength,
    attributeStyle: attributeStyle,
    offerTimerProps: offerTimerProps
  }, item))));
  const action = showFullListBtn ? {
    label: constants/* LABEL_SHOW_FULL_LIST */.dz,
    props: constants/* ICON_SHOW_FULL_LIST */.Bl
  } : {
    label: constants/* LABEL_SHOW_MORE */.K9,
    props: constants/* ICON_SHOW_MORE */.Uh
  };
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref,
    "data-testid": "product-list"
  }, rest), /*#__PURE__*/react.createElement(product_list_styles_List, (0,esm_extends/* default */.Z)({}, props, {
    variant: "light",
    displayMode: displayMode,
    gridGap: gridGap,
    renderAction: (collapsed || showFullListBtn || showMoreBtn) && partial < data.length && /*#__PURE__*/react.createElement(ListAction, (0,esm_extends/* default */.Z)({
      onClick: () => {
        onClickLoadMore();
        setCollapsed(!collapsed);
      }
    }, action.props), action.label)
  }), Products), jsonLD && data && /*#__PURE__*/react.createElement(JsonLD/* default */.ZP, {
    schema: data.filter(item => {
      var _item$price;

      return (_item$price = item.price) == null ? void 0 : _item$price.price;
    }).map(item => (0,JsonLD/* productSchema */.Iy)({
      product: item,
      isList: true
    }, domain)),
    type: "ItemList"
  }));
});
 false ? 0 : void 0;
ProductList.defaultProps = {
  hidePriceButtonAction: null,
  showFullListBtn: false,
  displayMode: 'gallery',
  domain: constants/* MAGALU_DOMAIN */.RW,
  lazyLoadingOffset: 50,
  showInCashInfo: true,
  imgLazyLoading: true,
  showWishBtn: false,
  showPreview: false,
  showMoreBtn: false,
  imageAltPrefix: '',
  hidePrice: false,
  showDiscountOnlyCashInfo: false,
  showDiscount: false,
  titleAs: 'h2',
  jsonLD: true,
  partial: 0,
  allowEmptyRating: false,
  onThumbnailClick: null,
  colorMinLength: 3,
  attributeStyle: {},
  onClickLoadMore: () => {},
  onClickWishBtn: () => {},
  previewAction: () => {},
  onClick: () => {},
  onMouseDown: () => {},
  onProductView: () => {}
};
/* harmony default export */ var product_list = (ProductList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js


/***/ }),

/***/ 99970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_review_gallery; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/helpers.js
const EXHIBITION_CARDS_DESKTOP = 5;
const EXHIBITION_CARDS_MOBILE = 2;
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/product-review-gallery.styles.js


const GridContainer = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj)`
  overflow-x: auto;
  padding: 16px 0;
`;
const GridCard = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Grid */.rj)`
  gap: 12px;
  display: flex;
  flex-wrap: nowrap;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/product-review-gallery.js






const ProductReviewGallery = ({
  children,
  isMobile
}) => {
  const [itemsPerView, setItemsPerView] = (0,react.useState)(EXHIBITION_CARDS_MOBILE);
  (0,react.useEffect)(() => {
    if (!isMobile) {
      setItemsPerView(EXHIBITION_CARDS_DESKTOP);
    }
  }, []);

  const renderCarousel = slidesPerView => {
    return /*#__PURE__*/react.createElement(Carousel/* default */.Z, {
      showArrowControls: true,
      showControls: false,
      auto: false,
      slidesPerView: slidesPerView
    }, children);
  };

  if (children.length > itemsPerView) {
    return renderCarousel(itemsPerView);
  }

  return /*#__PURE__*/react.createElement(GridContainer, {
    "data-testid": "gallery-without-carousel"
  }, /*#__PURE__*/react.createElement(GridCard, null, children));
};

 false ? 0 : void 0;
/* harmony default export */ var product_review_gallery = (ProductReviewGallery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/index.js


/***/ }),

/***/ 77576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ product_review_popup; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/rotateImage.js
var rotateImage = __webpack_require__(42952);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MediaContainer/media-container.styles.js


const Video = (0,styled_components_browser_esm/* default */.ZP)('video')`
  width: 100%;
  margin: auto;
  max-height: 55vh;
  border-radius: 15px;

  @media screen and (max-width: 499px) {
    max-height: 60vh;
  }
`;
const ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div`
  height: 100%;
  border-radius: 15px;
  overflow: hidden;

  @media screen and (max-width: 499px) {
    border-radius: 12px;
  }
`;
const PopupImage = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)`
  display: block;
  max-height: 55vh;
  object-fit: cover;
  width: auto;
  max-width: 100%;
  border-radius: 15px;

  @media screen and (max-width: 499px) {
    max-height: 60vh;
  }
`;
const ImageContainer = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MediaContainer/media-container.js




const MediaContainer = ({
  media,
  alt,
  currentSlide,
  index
}) => {
  const videoRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if (videoRef.current && currentSlide !== index) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [currentSlide, index]);
  return /*#__PURE__*/react.createElement(ImageContainer, null, media.mediaType === 'image' ? /*#__PURE__*/react.createElement(ImageWrapper, null, /*#__PURE__*/react.createElement(PopupImage, {
    alt: alt,
    lazy: true,
    src: media.mediaUrl
  })) : /*#__PURE__*/react.createElement(Video, {
    ref: videoRef,
    muted: true,
    controls: true,
    type: "video/mp4",
    src: media.mediaUrl,
    disablePictureInPicture: true,
    controlsList: "nodownload noplaybackrate"
  }));
};

 false ? 0 : void 0;
/* harmony default export */ var media_container = (MediaContainer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MediaContainer/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Avatar/index.js + 2 modules
var Avatar = __webpack_require__(78045);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Carousel/index.js + 4 modules
var Carousel = __webpack_require__(49542);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Review/index.js + 2 modules
var Review = __webpack_require__(73172);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MobileReviewPopup/mobile-review-popup.styles.js





const ModalDetails = styled_components_browser_esm/* default.div */.ZP.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 20px 16px;
  z-index: ${(0,build_esm/* themeGet */.R)('zIndices.4')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (min-width: 500px) {
    display: none;
  }
`;
const DescriptionBlock = styled_components_browser_esm/* default.div */.ZP.div`
  color: white;
  text-align: start;
  width: 100%;
`;
const ModalDetailsBody = styled_components_browser_esm/* default.div */.ZP.div`
  margin: auto;
  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 720px;
    gap: 30px;
  }
`;
const ModalDetailsHeader = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  display: flex;
  justify-content: end;
  width: 100%;
`;
const CloseButton = styled_components_browser_esm/* default.button */.ZP.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const SeeMore = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
const CaroulselBlock = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: calc(100% - 80px);
  margin: auto;
  ${(0,build_esm/* getMediaQuery */.aK)('medium')} {
    max-width: 280px;
  }
`;
const ReviewContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)``;
const Header = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  padding: 0 0 ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;
  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    padding: 0 0 ${props => (0,build_esm/* themeGet */.R)('space.3')(props)}px;
  }
`;
const ReviewerName = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => (0,build_esm/* getTextColor */.uu)('white')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  padding: ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
`;
const ReviewWrapper = styled_components_browser_esm/* default.span */.ZP.span`
  width: 80px;
`;
const RotateButtonBlock = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  width: 100%;
  height: 32px;
  margin: 18px 0 0;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var stereo_ui_utils_build_esm = __webpack_require__(71180);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/helpers.js

const validateShortDescription = (description, charLimit) => {
  return (description == null ? void 0 : description.length) <= charLimit;
};
const reduceDescription = (description, charLimit) => {
  return description == null ? void 0 : description.substring(0, charLimit).concat('...');
};
const verifyTimestamp = date => {
  return /^\d+$/.test(date);
};
const generateDateDistance = date => {
  return date && !verifyTimestamp(date) && (0,stereo_ui_utils_build_esm/* formatDateDistance */.jL)(new Date(date), new Date());
};
const formatSubtitle = productAttributes => {
  return (productAttributes == null ? void 0 : productAttributes.map((el, index) => index === 0 ? `${el.label}: ${el.value}` : ` | ${el.label}: ${el.value}`)) || [];
};
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MobileReviewPopup/mobile-review-popup.js










const MobileReviewPopup = ({
  charLimit,
  children,
  closePopup,
  selectedMedia,
  review,
  changeCaroulsel,
  showRotateButton,
  onRotateImage
}) => {
  const [seeMore, setSeeMore] = (0,react.useState)(false);
  const {
    rating,
    description,
    userData
  } = review;
  const isShortDescription = validateShortDescription(description, charLimit);
  const reducedDescription = reduceDescription(description, charLimit);
  return /*#__PURE__*/react.createElement(ModalDetails, null, /*#__PURE__*/react.createElement(ModalDetailsHeader, null, /*#__PURE__*/react.createElement(CloseButton, {
    "data-testid": "close-popup",
    "aria-label": "fechar popup",
    onClick: closePopup
  }, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "Close",
    color: "#FFF"
  }))), /*#__PURE__*/react.createElement(CaroulselBlock, null, /*#__PURE__*/react.createElement(Carousel/* default */.Z, {
    auto: false,
    goTo: selectedMedia,
    verticalAlign: "center",
    onChange: changeCaroulsel
  }, children), /*#__PURE__*/react.createElement(RotateButtonBlock, {
    justifyContent: "center",
    alignItems: "center"
  }, showRotateButton && /*#__PURE__*/react.createElement(Button/* default */.Z, {
    variation: "outline",
    size: "small",
    onClick: onRotateImage,
    startIcon: /*#__PURE__*/react.createElement(esm/* ExchangeCircle */.tnm, {
      width: 20,
      height: 20
    }),
    centered: true
  }, "Girar imagem"))), /*#__PURE__*/react.createElement(ReviewContainer, {
    container: true
  }, /*#__PURE__*/react.createElement(Header, null, /*#__PURE__*/react.createElement(Avatar/* default */.Z, null), /*#__PURE__*/react.createElement(ReviewerName, null, userData.name), /*#__PURE__*/react.createElement(ReviewWrapper, null, /*#__PURE__*/react.createElement(Review/* default */.Z, {
    score: rating
  }))), /*#__PURE__*/react.createElement(DescriptionBlock, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : reducedDescription, "\xA0", !isShortDescription && /*#__PURE__*/react.createElement(SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos'))));
};

 false ? 0 : void 0;
MobileReviewPopup.defaultProps = {
  charLimit: 110,
  changeCaroulsel: () => 0
};
/* harmony default export */ var mobile_review_popup = (MobileReviewPopup);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/MobileReviewPopup/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MediaReviewCard/index.js + 2 modules
var MediaReviewCard = __webpack_require__(97949);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/index.js + 3 modules
var ProductReviewGallery = __webpack_require__(99970);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/WebReviewPopup/web-review-popup.styles.js







const web_review_popup_styles_Header = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  align-items: center;
  padding: 0 0 ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    padding: 0 0 ${props => (0,build_esm/* themeGet */.R)('space.3')(props)}px;
  }
`;
const web_review_popup_styles_ReviewerName = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${props => (0,build_esm/* themeGet */.R)('colors.darkSilver')(props)};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  padding: ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
`;
const SubTitle = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${(0,build_esm/* getTextColor */.uu)('davysGray')};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
`;
const DateWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(() => ({
  fontSize: 2
}))`
  color: ${(0,build_esm/* getTextColor */.uu)('davysGray')};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.tall')(props)}px;
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(() => ({
  fontSize: 3
}))`
  color: ${(0,build_esm/* themeGet */.R)('colors.black')};
  font-weight: ${(0,build_esm/* themeGet */.R)('fontWeights.regular')};
  line-height: 24px;
  padding: ${(0,build_esm/* themeGet */.R)('space.3')}px 0 ${(0,build_esm/* themeGet */.R)('space.3')}px;
  word-break: break-word;
  width: 100%;
`;
const web_review_popup_styles_ModalDetailsBody = styled_components_browser_esm/* default.div */.ZP.div`
  margin: 25px 0;
  display: flex;
  width: 100%;
  gap: 40px;
`;
const web_review_popup_styles_SeeMore = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(() => ({
  color: 'primary.base',
  fontSize: 1
}))`
  display: inline;
  text-decoration: underline;
  cursor: pointer;
`;
const web_review_popup_styles_ReviewWrapper = styled_components_browser_esm/* default.span */.ZP.span`
  width: 80px;
`;
const web_review_popup_styles_CaroulselBlock = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  gap: 18px;
  width: 50%;
`;
const web_review_popup_styles_ReviewContainer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  width: 50%;
`;
const DialogStyled = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)`
  width: 720px;
  background-color: ${(0,build_esm/* getPaletteColor */.ow)('background.lighter')};
  padding: 20px;
  display: none;

  @media screen and (min-width: 500px) {
    display: block;
  }
`;
const DialogContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  min-height: 400px;
`;
const CondensedMediasBlock = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  width: 100%;
`;
const RotateButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z)`
  width: 50%;
`;
const web_review_popup_styles_RotateButtonBlock = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  width: 100%;
  height: 32px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/WebReviewPopup/web-review-popup.js










const modalTitleStyle = {
  color: '#51585C',
  fontWeight: 'bold'
};

const WebReviewPopup = ({
  changeCaroulsel,
  charLimit,
  children,
  closePopup,
  review,
  selectedMedia,
  thumbnails,
  showRotateButton,
  onRotateImage
}) => {
  const [seeMore, setSeeMore] = (0,react.useState)(false);
  const [selectedCondensedMedia, setSelectedCondensedMedia] = (0,react.useState)(selectedMedia);
  const {
    rating,
    description,
    submissionDate,
    attributes,
    userData
  } = review;
  const isShortDescription = validateShortDescription(description, charLimit);
  const reducedDescription = reduceDescription(description, charLimit);
  const days = generateDateDistance(submissionDate);
  const subtitle = formatSubtitle(attributes);

  const renderGallery = () => {
    const renderedCards = thumbnails.map((media, index) => {
      return /*#__PURE__*/react.createElement(MediaReviewCard/* default */.Z, {
        key: `caroulsel-card-${media.mediaUrl}`,
        media: media,
        onClick: () => setSelectedCondensedMedia(index)
      });
    });
    return /*#__PURE__*/react.createElement(ProductReviewGallery/* default */.Z, null, renderedCards);
  };

  return /*#__PURE__*/react.createElement(DialogStyled, {
    position: "center",
    showClose: true,
    type: "responsive",
    onClickOutside: closePopup,
    title: "Avalia\xE7\xF5es com m\xEDdias",
    titleStyle: modalTitleStyle
  }, /*#__PURE__*/react.createElement(DialogContent, {
    flexDirection: "column",
    justifyContent: "space-between"
  }, /*#__PURE__*/react.createElement(web_review_popup_styles_ModalDetailsBody, null, /*#__PURE__*/react.createElement(web_review_popup_styles_CaroulselBlock, {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/react.createElement(Carousel/* default */.Z, {
    showSlideCount: true,
    showArrowControls: true,
    showControls: false,
    auto: false,
    goTo: selectedCondensedMedia,
    verticalAlign: 'center',
    onChange: changeCaroulsel
  }, children), /*#__PURE__*/react.createElement(web_review_popup_styles_RotateButtonBlock, {
    justifyContent: "center",
    alignItems: "center"
  }, showRotateButton && /*#__PURE__*/react.createElement(RotateButton, {
    variation: "outline",
    size: "small",
    onClick: onRotateImage,
    startIcon: /*#__PURE__*/react.createElement(esm/* ExchangeCircle */.tnm, {
      width: 20,
      height: 20
    }),
    centered: true
  }, "Girar imagem"))), /*#__PURE__*/react.createElement(web_review_popup_styles_ReviewContainer, {
    container: true
  }, /*#__PURE__*/react.createElement(web_review_popup_styles_Header, null, /*#__PURE__*/react.createElement(Avatar/* default */.Z, null), /*#__PURE__*/react.createElement(web_review_popup_styles_ReviewerName, null, userData.name), /*#__PURE__*/react.createElement(web_review_popup_styles_ReviewWrapper, null, /*#__PURE__*/react.createElement(Review/* default */.Z, {
    score: rating
  }))), subtitle.length > 0 && /*#__PURE__*/react.createElement(SubTitle, {
    "data-testid": "review-sub-title"
  }, subtitle), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : reducedDescription, "\xA0", !isShortDescription && /*#__PURE__*/react.createElement(web_review_popup_styles_SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos')), days && /*#__PURE__*/react.createElement(DateWrapper, {
    "data-testid": "review-date"
  }, `há ${days}`))), /*#__PURE__*/react.createElement(CondensedMediasBlock, null, renderGallery())));
};

 false ? 0 : void 0;
WebReviewPopup.defaultProps = {
  charLimit: 110,
  reviewDate: null,
  subtitle: ''
};
/* harmony default export */ var web_review_popup = (WebReviewPopup);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/Components/WebReviewPopup/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/product-review-popup.js






const rotationAngle = 90;

const ProductReviewPopup = ({
  review,
  charLimit,
  mediaProps,
  selectedMedia,
  closePopup,
  changeCaroulsel
}) => {
  const [currentSlide, setCurrentSlide] = (0,react.useState)(selectedMedia);
  const [showRotateButton, setShowRotateButton] = (0,react.useState)(false);
  const [rotation, setRotation] = (0,react.useState)(0);
  const thumbnails = mediaProps.filter(item => item.thumbnails);
  const processedMedias = mediaProps.filter(item => item.processed);

  const verifyMediaType = index => {
    setShowRotateButton(processedMedias[index].mediaType !== 'video');
  };

  const handleSlideChange = index => {
    setCurrentSlide(index);
    verifyMediaType(index);
    changeCaroulsel(index);
  };

  const handleRotateImage = async () => {
    try {
      processedMedias[currentSlide].mediaUrl = await (0,rotateImage/* rotateImage */.N)(processedMedias[currentSlide].mediaUrl, rotationAngle);
      setRotation(prevRotation => prevRotation + rotationAngle);
    } catch (error) {
      console.error(`Falha ao rotacionar imagem: ${error}`);
    }
  };

  const renderMedia = (0,react.useCallback)(() => {
    return processedMedias.map((elem, index) => {
      return /*#__PURE__*/react.createElement(media_container, {
        key: `slide-item-${elem.mediaUrl}`,
        media: elem,
        alt: '',
        currentSlide: currentSlide,
        index: index
      });
    });
  }, [mediaProps, currentSlide, rotation]);

  const closePopupAction = () => {
    document.body.style.overflow = 'visible';
    closePopup();
  };

  const renderPopup = () => {
    if (window.innerWidth >= 500) {
      return /*#__PURE__*/react.createElement(web_review_popup, {
        charLimit: charLimit,
        closePopup: closePopup,
        review: review,
        selectedMedia: selectedMedia,
        changeCaroulsel: handleSlideChange,
        thumbnails: thumbnails,
        showRotateButton: showRotateButton,
        onRotateImage: handleRotateImage
      }, renderMedia());
    }

    document.body.style.overflow = 'hidden';
    return /*#__PURE__*/react.createElement(mobile_review_popup, {
      charLimit: charLimit,
      closePopup: closePopupAction,
      review: review,
      selectedMedia: selectedMedia,
      changeCaroulsel: handleSlideChange,
      showRotateButton: showRotateButton,
      onRotateImage: handleRotateImage
    }, renderMedia());
  };

  return renderPopup();
};

 false ? 0 : void 0;
ProductReviewPopup.defaultProps = {
  charLimit: 110,
  changeCaroulsel: () => 0
};
/* harmony default export */ var product_review_popup = (ProductReviewPopup);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/index.js


/***/ }),

/***/ 79534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ review_form; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewForm/review-form.styles.js




const Row = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  padding-bottom: ${(0,esm/* themeGet */.R)('space.2')}px;
`;
const Tiny = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  text-decoration: underline;
  cursor: pointer;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewForm/review-form.js


function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }







function ReviewForm({
  agreedError,
  agreedLabel,
  buttonLabel,
  onSubmit,
  ratingError,
  ratingLabel,
  recommendedError,
  recommendedLabel,
  reviewCharacteristics,
  minTextSize,
  textError,
  textLabel,
  textPlaceholder,
  titleError,
  titleLabel,
  titlePlaceholder,
  focus
}) {
  const [agreed, setAgreed] = (0,react.useState)(false);
  const [recommended, setRecommended] = (0,react.useState)('');
  const [rating, setRating] = (0,react.useState)('');
  const [title, setTitle] = (0,react.useState)('');
  const [text, setText] = (0,react.useState)('');
  const [characteristics, setCharacteristics] = (0,react.useState)(reviewCharacteristics || []);
  const [errorsValidation, setErrorsValidation] = (0,react.useState)({});
  const refs = Object.assign({
    rating: (0,react.useRef)(),
    title: (0,react.useRef)(),
    text: (0,react.useRef)(),
    recommended: (0,react.useRef)()
  }, characteristics.reduce((acc, {
    id
  }) => Object.assign({}, acc, {
    [id]: (0,react.useRef)()
  }), {}), {
    agreed: (0,react.useRef)()
  });
  const updateErrors = (0,react.useCallback)((_key, _error, _focus = focus) => {
    setErrorsValidation(_ref => {
      let errs = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, [_key].map(_toPropertyKey));

      const errors = Object.assign({}, errs, _error);
      const keys = Object.keys(errors);

      if (_focus && keys.includes(_key) && _error) {
        const {
          current
        } = refs[keys[0]];
        window.scroll({
          top: current.offsetTop - 35,
          left: 0,
          behavior: 'smooth'
        });
      }

      return errors;
    });
  }, [errorsValidation]);
  const validateLength = (0,react.useCallback)((_value, _key, _length, _message, _focus) => {
    const error = _value.length < _length ? {
      [_key]: _message
    } : undefined;
    updateErrors(_key, error, _focus);
    return error;
  }, [rating, title, text, recommended, characteristics, agreed]);
  const validatePresence = (0,react.useCallback)((_value, _key, _message, _focus) => {
    const error = !_value ? {
      [_key]: _message
    } : undefined;
    updateErrors(_key, error, _focus);
    return error;
  }, [rating, title, text, recommended, characteristics, agreed]);
  const clearForm = (0,react.useCallback)(() => {
    setRating('');
    setTitle('');
    setText('');
    setRecommended('');
    setAgreed(false);
    setCharacteristics(reviewCharacteristics.map(_ref2 => {
      let rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["value"]);

      return rest;
    }));
  }, [reviewCharacteristics]);
  const handleSubmit = (0,react.useCallback)(e => {
    const errors = Object.assign({}, validatePresence(rating, 'rating', ratingError), validatePresence(title, 'title', titleError), validateLength(text, 'text', minTextSize, textError), validatePresence(recommended, 'recommended', recommendedError), characteristics.reduce((acc, characteristic) => Object.assign({}, acc, validatePresence(characteristic.value, characteristic.id, ratingError)), {}), validatePresence(agreed, 'agreed', agreedError));

    if (!Object.keys(errors).length) {
      onSubmit({
        rating,
        title,
        text,
        recommended,
        characteristics
      }, clearForm);
    }

    e.preventDefault();
  }, [rating, title, text, recommended, agreed, characteristics]);
  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    as: "form",
    "data-testid": "review-form"
  }, /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => {
      validatePresence(e.target.value, 'rating', ratingError, false);
      setRating(e.target.value);
    },
    ref: refs.rating,
    value: rating,
    error: errorsValidation.rating,
    type: "rating",
    label: ratingLabel,
    height: [40, 30],
    width: [40, 30],
    gap: [0, 30],
    fontSize: [4, 2],
    fontWeight: ['bold', 'regular'],
    flexDirection: ['column', 'row'],
    alignItems: "center",
    textAlign: ['center', 'right'],
    name: "rating"
  })), /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => setTitle(e.target.value),
    onFocus: () => setErrorsValidation(_ref3 => {
      let errors = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, ["title"]);

      return errors;
    }),
    onBlur: e => validatePresence(e.target.value, 'title', titleError, false),
    ref: refs.title,
    value: title,
    error: errorsValidation.title,
    type: "text",
    label: titleLabel,
    placeholder: titlePlaceholder,
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    textAlign: ['left', 'right']
  })), /*#__PURE__*/react.createElement(Row, null, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => setText(e.target.value),
    onFocus: () => setErrorsValidation(_ref4 => {
      let errors = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref4, ["text"]);

      return errors;
    }),
    onBlur: e => validateLength(e.target.value, 'text', 50, textError, false),
    ref: refs.text,
    value: text,
    error: errorsValidation.text,
    type: "textarea",
    label: textLabel,
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    textAlign: ['left', 'right'],
    placeholder: textPlaceholder
  })), /*#__PURE__*/react.createElement(Row, {
    borderBottomWidth: ['1px', '0px'],
    borderBottomStyle: "solid",
    borderColor: "lightSilver"
  }, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => {
      validatePresence(e.target.value, 'recommended', recommendedError, false);
      setRecommended(e.target.value);
    },
    ref: refs.recommended,
    value: recommended,
    error: errorsValidation.recommended,
    type: "recommendation",
    label: recommendedLabel,
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    alignItems: "center",
    textAlign: ['center', 'right']
  })), characteristics == null ? void 0 : characteristics.map(({
    id,
    label,
    value
  }) => /*#__PURE__*/react.createElement(Row, {
    key: id,
    borderBottomWidth: ['1px', '0px'],
    borderBottomStyle: "solid",
    borderColor: "lightSilver"
  }, /*#__PURE__*/react.createElement(molecules/* ReviewInput */.qr, {
    onChange: e => {
      validatePresence(e.target.value, id, ratingError, false);
      setCharacteristics(characteristics.map(characteristic => {
        if (characteristic.id === id) {
          return Object.assign({}, characteristic, {
            value: e.target.value
          });
        }

        return characteristic;
      }));
    },
    name: id,
    ref: refs[id],
    value: value,
    error: errorsValidation[id],
    label: label,
    type: "rating",
    height: [30, 24],
    width: [30, 24],
    gap: [0, 30],
    flexDirection: ['column', 'row'],
    alignItems: "center",
    textAlign: ['center', 'right']
  }))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    m: 20,
    flexDirection: ['column', 'row'],
    gap: [0, 30]
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "0.75"
  }), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "1",
    gap: "2",
    alignItems: ['center', 'start'],
    justifyContent: "space-evenly",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(atoms/* Checkbox */.XZ, {
    ref: refs.agreed,
    checked: agreed,
    onChange: e => {
      validatePresence(e.target.checked, 'agreed', agreedError, false);
      setAgreed(e.target.checked);
    }
  }, agreedLabel), errorsValidation.agreed && /*#__PURE__*/react.createElement(atoms/* Text */.xv, {
    color: "error.base"
  }, errorsValidation.agreed))), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    mY: 20,
    flexDirection: ['column', 'row'],
    gap: [0, 30]
  }, /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "0.75"
  }), /*#__PURE__*/react.createElement(atoms/* Flex */.kC, {
    flex: "1",
    gap: "2",
    alignItems: ['center', 'start'],
    justifyContent: "space-evenly",
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    onClick: handleSubmit,
    full: true
  }, buttonLabel))));
}

ReviewForm.defaultProps = {
  agreedError: 'Por favor verifique os termos.',
  agreedLabel: 'Concordo com os termos e condições',
  buttonLabel: 'Enviar avaliação',
  ratingError: 'Clique nas estrelas para classificar!',
  ratingLabel: 'Avaliação Geral',
  recommendedError: 'Por favor selecione uma opção.',
  recommendedLabel: 'Você recomenda esse produto?',
  minTextSize: 50,
  textError: 'Mínimo de 50 caracteres.',
  textLabel: 'Avaliação',
  titleError: 'Insira o título completo corretamente.',
  titleLabel: 'Título da avaliação',
  titlePlaceholder: 'Ex. Produto Maravilhoso',
  textPlaceholder: 'Ex: Escreva exclusivamente sobre o produto. Para sugestões, reclamações ou problemas em geral, acesse nossa Central de Atendimento',
  focus: true
};
 false ? 0 : void 0;
/* harmony default export */ var review_form = (ReviewForm);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewForm/index.js


/***/ }),

/***/ 4506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ review_stats; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/review-stats.styles.js





const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Main = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > div {
    display: flex;
    align-items: center;
  }
`;
const Score = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.7')(props)}px;
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('light')(props)};
`;
const Divider = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  border-left: 3px solid ${props => (0,build_esm/* getBorderColor */.kJ)('light')(props)};
  height: 90px;
  margin: 0px 24px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/review-stats.js







function ReviewStats({
  average,
  count: total,
  distribution,
  actionLabel,
  onReviewButtonClick
}) {
  const desc = total > 1 ? `${total} avaliações` : `${total} avaliação`;
  distribution.sort((a, b) => b.value - a.value);
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Container, {
    mb: [3, 3, 3]
  }, /*#__PURE__*/react.createElement(Main, null, /*#__PURE__*/react.createElement("div", null, /*#__PURE__*/react.createElement(Score, {
    "data-testid": "stat-score"
  }, average.toFixed(1)), /*#__PURE__*/react.createElement(esm/* Star */.Uxw, {
    width: "50px",
    height: "50px",
    color: "#FFCC03"
  })), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "stat-desc"
  }, desc)), /*#__PURE__*/react.createElement(Divider, null), /*#__PURE__*/react.createElement("ul", null, distribution == null ? void 0 : distribution.map(item => /*#__PURE__*/react.createElement(molecules/* RatingLine */.me, {
    key: item.value,
    id: item.value,
    score: item.count,
    count: item.count,
    max: total
  })))), !!actionLabel && /*#__PURE__*/react.createElement(Button/* default */.Z, {
    full: true,
    variation: "fill",
    size: "medium",
    color: "primary",
    onClick: e => onReviewButtonClick(e, {
      average,
      distribution,
      desc,
      total
    })
  }, actionLabel));
}

ReviewStats.defaultProps = {
  actionLabel: 'Quero avaliar',
  average: 0,
  count: 0,
  distribution: [],
  onReviewButtonClick: () => ({})
};
 false ? 0 : void 0;
/* harmony default export */ var review_stats = (ReviewStats);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/index.js


/***/ }),

/***/ 30143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ seller_delivery; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js + 21 modules
var organisms = __webpack_require__(46514);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/seller-delivery.styles.js




const Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  color: ${props => props.color || (0,build_esm/* getTextColor */.uu)('scratched')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.regular')(props)};
  margin-right: 4px;
  line-height: ${props => props.lineHeight || `20px`};
`;
const Link = styled_components_browser_esm/* default.label */.ZP.label`
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  text-decoration: ${({
  disableClick
}) => disableClick ? 'none' : 'underline'};
  cursor: ${({
  disableClick
}) => disableClick ? 'default' : 'pointer'};
`;
const PartnerLink = styled_components_browser_esm/* default.a */.ZP.a`
  cursor: pointer;

  svg {
    vertical-align: middle;
  }
`;
const LogoMagaluIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* LogoMagalu */.ZGh).attrs(props => ({
  color: `${props.logoIconColor || (0,build_esm/* getPaletteColor */.ow)('base')(props)}`,
  width: 60,
  height: 14,
  viewBox: '0 0 60 14'
}))`
  vertical-align: middle;
  margin-top: 4px;
`;
const Content = styled_components_browser_esm/* default.div */.ZP.div`
  padding: 15px 15px;
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.5')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
`;
const Offers = styled_components_browser_esm/* default.a */.ZP.a`
  height: 20px;
  display: flex;
  align-items: center;
  margin: 28px 0;
  text-decoration: none;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  color: ${props => (0,build_esm/* getTextColor */.uu)('primary')(props)};
  cursor: pointer;
`;
const ChevronRightIcon = (0,styled_components_browser_esm/* default */.ZP)(esm/* ChevronRight */._Qn).attrs(props => ({
  color: (0,build_esm/* getTextColor */.uu)('primary')(props)
}))`
  vertical-align: middle;
  width: 20px;
  height: 20px;
`;
const Detail = styled_components_browser_esm/* default.div */.ZP.div`
  margin: 0 0 15px;
`;
const DetailLabel = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.3')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  padding: 0 0 5px;
`;
const DetailText = styled_components_browser_esm/* default.p */.ZP.p`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('greyish')(props)};
  padding: 0 0 5px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/content-box.js






const partnerProps = {
  bg: '#f0f0f2',
  borderRadius: 8,
  p: 2,
  mb: 2,
  alignItems: 'center'
};

const ContentBox = _ref => {
  let {
    id,
    delivery,
    handleLabelName,
    internationalPartner,
    partnerColor
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["id", "delivery", "handleLabelName", "internationalPartner", "partnerColor"]);

  if (!delivery && !id) return null;
  return !delivery || (id == null ? void 0 : id.toUpperCase()) === (delivery == null ? void 0 : delivery.toUpperCase()) ? /*#__PURE__*/react.createElement(atoms/* Box */.xu, internationalPartner ? partnerProps : props, /*#__PURE__*/react.createElement(Label, (0,esm_extends/* default */.Z)({}, internationalPartner ? {
    color: partnerColor,
    lineHeight: '16px'
  } : {}, {
    "data-testid": "label"
  }), "Vendido e entregue por ", handleLabelName(delivery))) : /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, /*#__PURE__*/react.createElement(Label, {
    "data-testid": "label"
  }, "Vendido por ", handleLabelName(id)), /*#__PURE__*/react.createElement(Label, {
    "data-testid": "label"
  }, "Entregue por ", handleLabelName(delivery)));
};

 false ? 0 : void 0;
ContentBox.defaultProps = {
  id: 'magazineluiza',
  delivery: 'magazineluiza',
  handleLabelName: () => {},
  internationalPartner: false
};
/* harmony default export */ var content_box = (ContentBox);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/seller-detail.js





const parseAddress = data => {
  const {
    address,
    number,
    district,
    city,
    state,
    zipcode
  } = data;
  const value = [];
  if (address && number) value.push(`${address}, ${number}`);
  if (city && state) value.push(`${district ? `${district} - ` : ''}${city}/${state}`);
  if (zipcode) value.push(`CEP: ${zipcode}`);
  return value;
};

const SellerDetail = ({
  seller,
  product,
  onOffersClick
}) => {
  const {
    id,
    description: title,
    deliveryId: delivery,
    details,
    href
  } = seller;
  const showInternationalSeller = (0,utils/* isInternationalPrice */.xx)(product == null ? void 0 : product.price);
  const addressData = parseAddress((details == null ? void 0 : details.address) || {});

  const docSeller = () => {
    return !showInternationalSeller ? {
      label: 'CNPJ',
      id: 'documentNumber',
      value: details == null ? void 0 : details.documentNumber
    } : {
      label: 'ID do Lojista',
      id: 'shippingDocumentNumber',
      value: details == null ? void 0 : details.shippingDocumentNumber
    };
  };

  const detailsParsed = [(details == null ? void 0 : details.legalName) && {
    label: 'Razão Social',
    id: 'legalName',
    value: details == null ? void 0 : details.legalName
  }, docSeller(), addressData.length && {
    label: 'Endereço',
    id: 'address',
    value: parseAddress(details == null ? void 0 : details.address)
  }];
  return /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Title, null, title), /*#__PURE__*/react.createElement(Offers, {
    href: href,
    onClick: e => onOffersClick(e, {
      id,
      delivery
    }),
    "data-testid": "offers-link"
  }, "Veja todas as ofertas dessa loja ", /*#__PURE__*/react.createElement(ChevronRightIcon, null)), detailsParsed.map((detail, index) => /*#__PURE__*/react.createElement(Detail, {
    key: `seller-detail-${index}`,
    "data-testid": "details"
  }, /*#__PURE__*/react.createElement(DetailLabel, null, detail == null ? void 0 : detail.label), Array.isArray(detail == null ? void 0 : detail.value) ? detail == null ? void 0 : detail.value.map(value => /*#__PURE__*/react.createElement(DetailText, {
    "data-testid": "details-value",
    key: `seller-value-${value}`
  }, value)) : /*#__PURE__*/react.createElement(DetailText, null, detail == null ? void 0 : detail.value))));
};

 false ? 0 : void 0;
SellerDetail.defaultProps = {
  seller: {
    id: 'magazineluiza',
    deliveryId: 'magazineluiza',
    description: 'Magalu',
    details: {}
  },
  product: {},
  onOffersClick: () => {}
};
/* harmony default export */ var seller_detail = (SellerDetail);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/magalu-companies.js

/* harmony default export */ var magalu_companies = ({
  zattini: {
    id: 'zattini',
    logo: esm/* LogoZattiniName */.fOR
  },
  netshoes: {
    id: 'netshoes',
    logo: esm/* LogoNetshoesName */.fOD
  },
  kabum: {
    id: 'kabum',
    logo: esm/* LogoKabum */.M0M
  },
  'epocacosmeticos-integra': {
    id: 'epoca',
    logo: esm/* LogoEpocaName */.uE5
  }
});
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/index.js + 2 modules
var SidebarHeader = __webpack_require__(83179);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/seller-delivery.js














const SellerDelivery = _ref => {
  let {
    showSellerDetailContent,
    onCloseModalContent,
    seller,
    product,
    onSellerClick,
    onOffersClick,
    disableSellerClick,
    disableSellerDetails,
    logoIconColor,
    showDialog,
    modal,
    internationalPartner,
    partnerColor,
    partnerLogo
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["showSellerDetailContent", "onCloseModalContent", "seller", "product", "onSellerClick", "onOffersClick", "disableSellerClick", "disableSellerDetails", "logoIconColor", "showDialog", "modal", "internationalPartner", "partnerColor", "partnerLogo"]);

  const {
    id,
    description: title,
    deliveryId: delivery
  } = seller;
  const [showSellerDetail, setShowSellerDetail] = (0,react.useState)(showSellerDetailContent);

  const handleShowDetails = e => {
    onSellerClick(e, {
      id,
      delivery
    });
    setShowSellerDetail(!disableSellerDetails);
  };

  const handleCloseModal = () => {
    setShowSellerDetail(false);
    onCloseModalContent();
  };

  react.useEffect(() => {
    setShowSellerDetail(showSellerDetailContent);
  }, [showSellerDetailContent]);

  const handleLabelName = label => {
    if (internationalPartner && partnerLogo) {
      return /*#__PURE__*/react.createElement(PartnerLink, {
        title: `Logo ${delivery}`,
        "data-testid": `${delivery}logo`,
        children: /*#__PURE__*/react.createElement(esm/* GenericImageIcon */.RdR, {
          href: partnerLogo,
          width: 77,
          height: 16
        }),
        onClick: disableSellerClick ? null : handleShowDetails
      });
    }

    if (label === constants/* DEFAULT_SELLER */.ig) {
      return /*#__PURE__*/react.createElement(LogoMagaluIcon, {
        title: "Logo magalu",
        "data-testid": "magalogo",
        logoIconColor: logoIconColor
      });
    }

    if (magalu_companies[label]) {
      const {
        id: partnerId,
        logo: Logo
      } = magalu_companies[label];
      return /*#__PURE__*/react.createElement(PartnerLink, {
        title: `Logo ${partnerId}`,
        "data-testid": `${partnerId}logo`,
        children: /*#__PURE__*/react.createElement(Logo, {
          preserveAspectRatio: true
        }),
        onClick: disableSellerClick ? null : handleShowDetails
      });
    }

    return /*#__PURE__*/react.createElement(Link, {
      onClick: disableSellerClick ? null : handleShowDetails,
      disableClick: disableSellerClick,
      children: title || delivery,
      "data-testid": "link"
    });
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(content_box, (0,esm_extends/* default */.Z)({
    id: id,
    delivery: delivery,
    handleLabelName: handleLabelName,
    internationalPartner: internationalPartner,
    partnerColor: partnerColor
  }, props)), !disableSellerClick && !showDialog && /*#__PURE__*/react.createElement(organisms/* Sidebar */.YE, {
    direction: "right",
    visible: showSellerDetail,
    onClickOutside: handleCloseModal,
    fullScreen: true,
    portal: true
  }, /*#__PURE__*/react.createElement(SidebarHeader/* default */.Z, {
    label: modal.title || 'Informações da loja parceira',
    align: "left",
    leftButton: {
      icon: 'back',
      title: 'Voltar para a pagina do produto',
      onClick: handleCloseModal
    }
  }), modal.content || /*#__PURE__*/react.createElement(seller_detail, {
    seller: seller,
    product: product,
    onOffersClick: onOffersClick
  })), !disableSellerClick && !disableSellerDetails && showDialog && /*#__PURE__*/react.createElement(atoms/* Dialog */.Vq, {
    visible: showSellerDetail,
    onClickOutside: handleCloseModal,
    position: "center",
    type: "responsive",
    showClose: true,
    title: modal.title,
    titleStyle: modal.titleStyle
  }, modal.content || /*#__PURE__*/react.createElement(seller_detail, {
    seller: seller,
    product: product,
    onOffersClick: onOffersClick
  })));
};

 false ? 0 : void 0;
SellerDelivery.defaultProps = {
  product: {},
  seller: {
    id: 'magazineluiza',
    deliveryId: 'magazineluiza',
    description: 'Magalu'
  },
  onSellerClick: () => {},
  onOffersClick: () => {},
  disableSellerClick: false,
  onCloseModalContent: () => ({}),
  showSellerDetailContent: false,
  disableSellerDetails: false,
  logoIconColor: '',
  showDialog: false,
  modal: {
    title: ''
  },
  internationalPartner: false
};
/* harmony default export */ var seller_delivery = (SellerDelivery);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js


/***/ }),

/***/ 2334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ shipping_list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ShippingList/shipping-list.js







const ShippingList = _ref => {
  let {
    items,
    currency
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["items", "currency"]);

  return /*#__PURE__*/react.createElement(atoms/* Box */.xu, props, items.map((shippingItem, index) => /*#__PURE__*/react.createElement(atoms/* Box */.xu, {
    key: `shipping-item-${index}`
  }, !!index && /*#__PURE__*/react.createElement(atoms/* HorizontalRule */.bo, null), /*#__PURE__*/react.createElement(molecules/* ShippingItem */.KI, (0,esm_extends/* default */.Z)({
    currency: currency
  }, shippingItem)))));
};

ShippingList.defaultProps = {
  items: [],
  currency: 'BRL'
};
 false ? 0 : void 0;
/* harmony default export */ var shipping_list = (ShippingList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ShippingList/index.js


/***/ }),

/***/ 75335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ showcase; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/index.js + 2 modules
var Card = __webpack_require__(27439);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/showcase.styles.js






const titleStyle = styled_components_browser_esm/* css */.iv`
  color: ${props => (0,esm/* getTextColor */.uu)('base')(props)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 97%;
`;
const container = {
  miniature: styled_components_browser_esm/* css */.iv`
    display: grid;
    padding: 8px 2px;
  `,
  list: styled_components_browser_esm/* css */.iv`
    display: grid;
    grid-template-columns: 1fr 2fr;
    padding: 16px;
  `,
  gallery: styled_components_browser_esm/* css */.iv``,
  none: styled_components_browser_esm/* css */.iv`
    display: contents;
  `,
  button: styled_components_browser_esm/* css */.iv`
    display: block;
    padding: 16px 16px 6px;
  `
};
const imgContainerDisplay = {
  miniature: styled_components_browser_esm/* css */.iv`
    height: 20vw;
    justify-content: flex-end;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
    }
  `,
  list: styled_components_browser_esm/* css */.iv`
    justify-content: flex-start;
    padding-top: 4px;
    min-height: 25vw;
  `,
  gallery: styled_components_browser_esm/* css */.iv`
    height: 32vw;
    justify-content: flex-end;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
    }
  `
};
const Display = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.ZP)`
  background-color: ${props => (0,esm/* getPaletteColor */.ow)('background.lighter')(props)};
  padding: 0;
  ${({
  displayMode
}) => displayMode && container[displayMode]}
`;
const ImageContainer = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-right: ${props => (0,esm/* themeGet */.R)('space.2')(props)}px;
  ${({
  displayMode
}) => displayMode && imgContainerDisplay[displayMode]}
`;
const TitleDisplay = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  grid-column-start: ${({
  betterOffer
}) => betterOffer && 2};
  ${({
  highlight,
  highlightType,
  sponsored
}) => highlight && !highlightType ? styled_components_browser_esm/* css */.iv`
          margin: ${(0,esm/* themeGet */.R)('space.0')}px ${(0,esm/* themeGet */.R)('space.2')}px;
        ` : styled_components_browser_esm/* css */.iv`
          margin-bottom: ${sponsored ? (0,esm/* themeGet */.R)('space.2') : (0,esm/* themeGet */.R)('space.3')}px;
        `};
`;
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(({
  highlight,
  fontSize
}) => ({
  fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : [highlight ? 1 : 2, 4, 5],
  lineHeight: 'display',
  fontWeight: 'medium'
}))`
  ${titleStyle}
  ${index_esm/* typography */.cp}

  & > span {
    font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.bold')(props)};
  }
`;
const ButtonTitle = styled_components_browser_esm/* default.h2 */.ZP.h2`
  ${titleStyle}
  height: 32px;
  line-height: ${props => (0,esm/* themeGet */.R)('lineHeights.plus')(props)}px;
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.regular')(props)};
  margin: 0 0 4px 0;
`;
const ProductCard = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
`;
const TextHighlight = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(() => ({
  fontSize: [1, 4, 5],
  lineHeight: 'display',
  fontWeight: 'regular'
}))`
  ${titleStyle}
  ${index_esm/* typography */.cp}
`;
const Content = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
`;
const Container = styled_components_browser_esm/* default.div */.ZP.div`
  box-shadow: ${({
  exhibition
}) => exhibition === 'highlight' ? '0 4px 10px 0 rgba(0, 0, 0, 0.11)' : 'unset'};
  border-radius: ${({
  exhibition
}) => exhibition === 'highlight' && '4px'};
  overflow: hidden;
  ${({
  exhibition
}) => exhibition === 'betteroffer' && styled_components_browser_esm/* css */.iv`
      display: grid;
      grid-template-rows: auto auto;
      padding: 24px 0;
      grid-template-columns: 1fr minmax(auto, 1376px) 1fr;
    `}
  ${index_esm/* space */.Dh}
  ${index_esm/* color */.$_}
  ${index_esm/* layout */.bK}
  ${index_esm/* border */.Cg}
`;
const ProductCardContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  flex: 1;
  flex: 0 0 calc(100% / 4);
  border-right: ${(0,esm/* themeGet */.R)('borders.0')};
  border-width: 2px;
`;
const SponsoredSubTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(() => ({
  fontSize: 0,
  color: 'light',
  marginTop: 1
}))``;
const ShowcaseContent = styled_components_browser_esm/* default.div */.ZP.div`
  grid-column-start: 2;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js + 3 modules
var ProductList = __webpack_require__(98284);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/highlight-title.js




const HighlightTitle = ({
  title,
  titleAs,
  titleSize,
  highlightType,
  showSponsoredSubTitle,
  betterOffer
}) => {
  const [prefix, highlight = '', suffix = ''] = title.split('"');
  const cleanSuffix = suffix.replace(', ', '');
  return /*#__PURE__*/react.createElement(TitleDisplay, {
    highlight: highlight,
    highlightType: highlightType,
    sponsored: showSponsoredSubTitle,
    betterOffer: betterOffer
  }, highlightType ? /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "product-title-head"
  }, prefix, " ", /*#__PURE__*/react.createElement("span", null, highlight), " ", cleanSuffix) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    highlight: highlight,
    "data-testid": "product-title-head"
  }, prefix), !!highlight && /*#__PURE__*/react.createElement(TextHighlight, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "text-highlight"
  }, highlight), !!cleanSuffix && /*#__PURE__*/react.createElement(Title, {
    as: titleAs,
    fontSize: titleSize,
    "data-testid": "text-suffix"
  }, cleanSuffix)), showSponsoredSubTitle && /*#__PURE__*/react.createElement(SponsoredSubTitle, {
    "data-testid": "sponsored-tag"
  }, "Patrocinados"));
};

 false ? 0 : void 0;
HighlightTitle.defaultProps = {
  title: '',
  titleAs: 'h2',
  highlightType: false,
  showSponsoredSubTitle: false,
  betterOffer: false
};
/* harmony default export */ var highlight_title = (HighlightTitle);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/rank.js







const Rank = _ref => {
  let {
    data,
    title,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showDiscountOnlyCashInfo,
    showDiscount
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "title", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showDiscountOnlyCashInfo", "showDiscount"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleSize: titleSize,
    titleAs: titleAs
  }), /*#__PURE__*/react.createElement(ProductList/* default */.Z, (0,esm_extends/* default */.Z)({
    data: data,
    displayMode: "list",
    enableShadow: false,
    exhibition: "rank",
    imageAltPrefix: imageAltPrefix,
    titleAs: productTitleAs,
    showInCashInfo: true,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount
  }, props)));
};

 false ? 0 : void 0;
/* harmony default export */ var rank = (Rank);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/list.js







const List = _ref => {
  let {
    data,
    title,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showFullListBtn,
    showMoreBtn,
    onClickLoadMore,
    showDiscountOnlyCashInfo,
    showDiscount,
    showSponsoredSubTitle
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "title", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showFullListBtn", "showMoreBtn", "onClickLoadMore", "showDiscountOnlyCashInfo", "showDiscount", "showSponsoredSubTitle"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleSize: titleSize,
    titleAs: titleAs,
    showSponsoredSubTitle: showSponsoredSubTitle
  }), /*#__PURE__*/react.createElement(ProductList/* default */.Z, (0,esm_extends/* default */.Z)({
    data: data,
    displayMode: "gallery",
    enableShadow: false,
    exhibition: "list",
    imageAltPrefix: imageAltPrefix,
    titleAs: productTitleAs,
    showFullListBtn: showFullListBtn,
    showMoreBtn: showMoreBtn,
    onClickLoadMore: onClickLoadMore,
    showInCashInfo: true,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo
  }, props)));
};

 false ? 0 : void 0;
/* harmony default export */ var list = (List);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/highlight.js









const Highlight = _ref => {
  let {
    data,
    highlight,
    title,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showDiscount,
    showDiscountOnlyCashInfo
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "highlight", "title", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showDiscount", "showDiscountOnlyCashInfo"]);

  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${highlight.title}` : highlight.title;
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Display, {
    as: "div",
    displayMode: "list",
    "data-testid": "product-card-container",
    hideLinkBorder: false
  }, /*#__PURE__*/react.createElement(ImageContainer, {
    displayMode: "list"
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    src: highlight.image,
    alt: imageAlt,
    lazy: true,
    offset: 2
  })), /*#__PURE__*/react.createElement(Content, {
    displayMode: "gallery",
    "data-testid": "product-card-content"
  }, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize
  }))), /*#__PURE__*/react.createElement(ProductList/* default */.Z, (0,esm_extends/* default */.Z)({
    data: data,
    displayMode: "gallery",
    enableShadow: false,
    exhibition: "highlight",
    imageAltPrefix: imageAltPrefix,
    titleAs: productTitleAs,
    showInCashInfo: true,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount
  }, props)));
};

 false ? 0 : void 0;
/* harmony default export */ var highlight = (Highlight);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/button.js








const Button = ({
  data,
  button,
  title,
  titleAs,
  titleSize,
  imageAltPrefix,
  productTitleAs,
  onClick,
  onMouseDown
}) => {
  const [highlight] = data;
  const imageAlt = imageAltPrefix ? `${imageAltPrefix}${highlight.title}` : highlight == null ? void 0 : highlight.title;
  return /*#__PURE__*/react.createElement(Display, {
    displayMode: "button",
    "data-testid": "product-card-container",
    hideLinkBorder: false,
    as: "div"
  }, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize
  }), /*#__PURE__*/react.createElement(ProductCard, null, /*#__PURE__*/react.createElement(ImageContainer, {
    displayMode: "list"
  }, /*#__PURE__*/react.createElement(ResponsiveImage/* default */.Z, {
    src: highlight == null ? void 0 : highlight.image,
    alt: imageAlt,
    lazy: true,
    offset: 2
  })), /*#__PURE__*/react.createElement(Content, {
    displayMode: "none",
    "data-testid": "product-card-content"
  }, /*#__PURE__*/react.createElement(TitleDisplay, {
    as: productTitleAs
  }, /*#__PURE__*/react.createElement(ButtonTitle, null, highlight == null ? void 0 : highlight.title)))), /*#__PURE__*/react.createElement(atoms/* Button */.zx, {
    "data-testid": "showcase-button",
    onClick: e => onClick(e, highlight),
    onMouseDown: e => onMouseDown(e, highlight),
    color: "secondary",
    startIcon: /*#__PURE__*/react.createElement(build_esm/* ShoppingBagFast */.tuM, {
      width: 32,
      height: 32
    }),
    m: '10px 0',
    full: true
  }, (button == null ? void 0 : button.label) || 'RETOMAR SUA COMPRA'));
};

 false ? 0 : void 0;
Button.defaultProps = {
  onMouseDown: () => {}
};
/* harmony default export */ var exhibitions_button = (Button);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 13 modules
var organisms_ProductCard = __webpack_require__(43125);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/carousel.js










const Carousel = _ref => {
  let {
    title,
    titleAs,
    titleSize,
    data,
    highlight,
    slidesPerView,
    showDiscount,
    showDiscountOnlyCashInfo,
    showSponsoredSubTitle,
    offerTimerProps
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["title", "titleAs", "titleSize", "data", "highlight", "slidesPerView", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "offerTimerProps"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize,
    highlightType: !!highlight,
    showSponsoredSubTitle: showSponsoredSubTitle
  }), /*#__PURE__*/react.createElement(Flex/* default */.Z, null, highlight && /*#__PURE__*/react.createElement(ProductCardContent, {
    slidesPerView: slidesPerView
  }, /*#__PURE__*/react.createElement(organisms_ProductCard/* default */.Z, (0,esm_extends/* default */.Z)({}, highlight, {
    displayMode: "gallery",
    showInCashInfo: true,
    titleAs: "h3",
    fullHeight: true,
    imageAltPrefix: "",
    imgLazyLoading: true,
    imageWidth: props.imageWidth,
    imageHeight: props.imageHeight,
    showRating: false,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount,
    key: `product-hightlight${highlight.variationId || highlight.id}`,
    offerTimerProps: offerTimerProps,
    enableHover: true
  }))), /*#__PURE__*/react.createElement(ProductCarousel/* default */.Z, (0,esm_extends/* default */.Z)({
    products: data,
    slidesPerView: highlight ? slidesPerView - 1 : slidesPerView,
    enableHover: !highlight,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showDiscount: showDiscount,
    offerTimerProps: offerTimerProps
  }, props))));
};

Carousel.defaultProps = {
  slidesPerView: 4
};
 false ? 0 : void 0;
/* harmony default export */ var carousel = (Carousel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/better-offer.js








const BetterOffer = _ref => {
  let {
    title,
    titleAs,
    titleSize,
    data,
    highlight,
    slidesPerViewBetterOffer,
    showSponsoredSubTitle,
    showButton,
    buttonProps
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["title", "titleAs", "titleSize", "data", "highlight", "slidesPerViewBetterOffer", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "showButton", "buttonProps"]);

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(highlight_title, {
    title: title,
    titleAs: titleAs,
    titleSize: titleSize,
    highlightType: !!highlight,
    showSponsoredSubTitle: showSponsoredSubTitle,
    betterOffer: true
  }), /*#__PURE__*/react.createElement(ShowcaseContent, null, /*#__PURE__*/react.createElement(ProductCarousel/* default */.Z, (0,esm_extends/* default */.Z)({
    products: data,
    slidesPerView: slidesPerViewBetterOffer,
    enableHover: !highlight,
    showDiscountOnlyCashInfo: false,
    showDiscount: false,
    fullHeight: false,
    exhibition: "betteroffer",
    gutter: 24,
    displayMode: "list",
    showRating: false,
    showOfferTimer: true,
    showPartialNextSlide: true,
    cardType: "horizontal",
    show: true,
    showBorder: true,
    showButton: showButton,
    buttonProps: buttonProps,
    hideOriginalPrice: true
  }, props))));
};

BetterOffer.defaultProps = {
  slidesPerViewBetterOffer: 2,
  showButton: false,
  buttonProps: {}
};
 false ? 0 : void 0;
/* harmony default export */ var better_offer = (BetterOffer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/exhibitions/index.js






const exhibitions = {
  rank: rank,
  list: list,
  highlight: highlight,
  button: exhibitions_button,
  carousel: carousel,
  betteroffer: better_offer
};
/* harmony default export */ var Showcase_exhibitions = (exhibitions);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/showcase.js






const Showcase = /*#__PURE__*/(0,react.forwardRef)((props, ref) => {
  var _ref;

  const {
    data,
    onClick,
    onMouseDown,
    onProductView,
    jsonLD,
    exhibition,
    titleAs,
    titleSize,
    imageAltPrefix,
    productTitleAs,
    showFullListBtn,
    showMoreBtn,
    onClickLoadMore,
    showInCashInfo,
    showDiscount,
    showDiscountOnlyCashInfo,
    showSponsoredSubTitle,
    slidesPerViewBetterOffer,
    showButton,
    buttonProps
  } = props,
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["data", "onClick", "onMouseDown", "onProductView", "jsonLD", "exhibition", "titleAs", "titleSize", "imageAltPrefix", "productTitleAs", "showFullListBtn", "showMoreBtn", "onClickLoadMore", "showInCashInfo", "showDiscount", "showDiscountOnlyCashInfo", "showSponsoredSubTitle", "slidesPerViewBetterOffer", "showButton", "buttonProps"]);

  (_ref = ref) !== null && _ref !== void 0 ? _ref : ref = (0,react.useRef)(null);
  const Exhibition = Showcase_exhibitions[exhibition] === undefined ? Showcase_exhibitions.rank : Showcase_exhibitions[exhibition];
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref,
    exhibition: exhibition
  }, rest), /*#__PURE__*/react.createElement(Exhibition, (0,esm_extends/* default */.Z)({
    data: data.products,
    title: data.title,
    highlight: data.highlight,
    button: data.button,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onProductView: onProductView,
    jsonLD: jsonLD,
    titleAs: titleAs,
    titleSize: titleSize,
    productTitleAs: productTitleAs,
    imageAltPrefix: imageAltPrefix,
    showFullListBtn: showFullListBtn,
    slidesPerViewBetterOffer: slidesPerViewBetterOffer,
    showMoreBtn: showMoreBtn,
    onClickLoadMore: onClickLoadMore,
    showInCashInfo: showInCashInfo,
    showDiscount: showDiscount,
    showDiscountOnlyCashInfo: showDiscountOnlyCashInfo,
    showSponsoredSubTitle: showSponsoredSubTitle,
    showButton: showButton,
    buttonProps: buttonProps
  }, rest)));
});
Showcase.defaultProps = {
  data: {
    title: null,
    products: []
  },
  onClick: () => false,
  onMouseDown: () => false,
  onProductView: () => {},
  exhibition: 'rank',
  jsonLD: true,
  titleAs: 'h2',
  productTitleAs: 'h3',
  imageAltPrefix: '',
  showFullListBtn: false,
  showMoreBtn: false,
  showInCashInfo: true,
  showDiscount: false,
  showDiscountOnlyCashInfo: false,
  showSponsoredSubTitle: false,
  slidesPerViewBetterOffer: 2,
  showButton: false,
  buttonProps: {}
};
 false ? 0 : void 0;
Showcase.displayName = 'Showcase';
/* harmony default export */ var showcase = (Showcase);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/index.js


/***/ }),

/***/ 83179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ sidebar_header; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/sidebar-header.styles.js




const handleGridAlign = {
  left: styled_components_browser_esm/* css */.iv`
    grid-template-columns: auto repeat(1, auto) 1fr;
  `,
  right: styled_components_browser_esm/* css */.iv`
    grid-template-columns: 1fr repeat(1, auto) auto;
  `,
  default: styled_components_browser_esm/* css */.iv`
    grid-template-columns: 1fr repeat(1, auto) 1fr;
  `
};
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  align-self: center;
  font-weight: 500;
`;
const LeftButton = styled_components_browser_esm/* default.div */.ZP.div`
  margin-right: auto;
`;
const Container = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  ${props => handleGridAlign[props == null ? void 0 : props.align] || handleGridAlign.default}
  gap: 0 10px;
  padding: 20px 16px;
  border-bottom: 1px solid ${props => (0,build_esm/* getBackgroundColor */.dF)('darker')(props)};
  ${index_esm/* space */.Dh}
  ${index_esm/* color */.$_}
  ${index_esm/* layout */.bK}
  ${index_esm/* border */.Cg}
  ${index_esm/* borderWidth */.J4}
  ${index_esm/* borderStyle */.$u}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/sidebar-header.js






const Icons = {
  close: esm/* Close */.x8P,
  back: esm/* ArrowBack */.xhZ
};

const SidebarHeader = _ref => {
  let {
    label,
    align,
    fontSize,
    leftButton,
    showCloseButton
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["label", "align", "fontSize", "leftButton", "showCloseButton"]);

  const {
    icon,
    title,
    onClick,
    iconColor = '#8c8c8c'
  } = leftButton;
  const LeftIcon = Icons[icon || 'close'];
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    align: align,
    "data-testid": "sidebar-header"
  }), /*#__PURE__*/react.createElement(LeftButton, null, showCloseButton && /*#__PURE__*/react.createElement(LeftIcon, {
    color: iconColor,
    role: "button",
    title: title,
    "data-testid": `${icon}-button`,
    onClick: onClick
  })), /*#__PURE__*/react.createElement(Title, (0,esm_extends/* default */.Z)({
    fontSize: fontSize
  }, props, {
    "data-testid": "title"
  }), label));
};

 false ? 0 : void 0;
SidebarHeader.defaultProps = {
  align: 'center',
  fontSize: 1,
  leftButton: {
    icon: 'close',
    onClick: () => {}
  },
  showCloseButton: true
};
/* harmony default export */ var sidebar_header = (SidebarHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/index.js


/***/ }),

/***/ 70615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ SidebarHeader/* default */.Z; },
  "Z": function() { return /* binding */ organisms_Sidebar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(39879);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/index.js + 5 modules
var Item = __webpack_require__(81572);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/sidebar.styles.js






const displayDirections = {
  left: styled_components_browser_esm/* css */.iv`
    left: 0;
    transform: ${({
    visible
  }) => visible ? 'translateX(0)' : 'translateX(-100%)'};
  `,
  right: styled_components_browser_esm/* css */.iv`
    right: 0;
    transform: ${({
    visible
  }) => visible ? 'translateX(0)' : 'translateX(100%)'};
  `
};
const Container = styled_components_browser_esm/* default.aside */.ZP.aside`
  z-index: ${props => (0,esm/* themeGet */.R)('zIndices.2')(props)};
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
`;
const Header = (0,styled_components_browser_esm/* default */.ZP)(Item/* default */.Z).attrs(props => ({
  borderBottom: `1px solid ${(0,esm/* getBackgroundColor */.dF)('darker')(props)}`
}))``;
const Content = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(_ref => {
  let {
    fullScreen
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["visible", "fullScreen"]);

  return {
    backgroundColor: (0,esm/* getBackgroundColor */.dF)((props == null ? void 0 : props.bg) || 'lighter')(props),
    zIndex: (0,esm/* themeGet */.R)('zIndices.3')(props),
    width: fullScreen ? '100%' : '80%',
    overflowX: 'hidden',
    position: 'fixed',
    overflowY: 'auto',
    textAlign: 'left',
    display: 'block',
    height: '100vh',
    // eslint-disable-next-line no-dupe-keys
    height: '100svh',
    top: 0
  };
})`
  ${index_esm/* color */.$_}

  ${({
  direction
}) => displayDirections[direction] || displayDirections.right}
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
  transition: ${({
  timeTransition
}) => `transform ${timeTransition}s ease-in-out`};

  /* mobile native toolbar */
  padding-bottom: 54px;
`;
const Overlay = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(_ref2 => {
  let {
    visible
  } = _ref2,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["visible"]);

  return {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: (0,esm/* themeGet */.R)('zIndices.2')(props),
    opacity: Number(visible),
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    top: 0
  };
})`
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
  transition: visibility 0s, opacity 0.3s linear;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Portal/index.js + 1 modules
var Portal = __webpack_require__(75851);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/SidebarHeader/index.js + 2 modules
var SidebarHeader = __webpack_require__(83179);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/sidebar-header.js







const sidebar_header_SidebarHeader = _ref => {
  let {
    children,
    variant,
    startIcon,
    fontSize,
    fontWeight,
    textAlign,
    ariaLabel,
    fill,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "variant", "startIcon", "fontSize", "fontWeight", "textAlign", "ariaLabel", "fill", "onClick"]);

  return /*#__PURE__*/react.createElement(Header, (0,esm_extends/* default */.Z)({
    variant: variant,
    scale: "large",
    startIcon: startIcon && /*#__PURE__*/react.createElement(build_esm/* Icon */.JO$, {
      name: startIcon,
      "aria-label": ariaLabel,
      fill: fill,
      onClick: onClick,
      "data-testid": "sidebar-header-icon"
    }),
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    "data-testid": "sidebar-header"
  }, props), children);
};

 false ? 0 : void 0;
sidebar_header_SidebarHeader.defaultProps = {
  children: null,
  variant: 'transparent',
  startIcon: 'ArrowBack',
  fontSize: 1,
  fontWeight: 'medium',
  textAlign: 'center',
  ariaLabel: 'fechar sidebar',
  fill: 'currentColor',
  onClick: () => {}
};
/* harmony default export */ var sidebar_header = (sidebar_header_SidebarHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/sidebar.js










const withPortal = children => /*#__PURE__*/react.createElement(Portal/* default */.Z, {
  id: "portal-sidebar"
}, children);

const SidebarWrapper = _ref => {
  let {
    portal = false
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["portal"]);

  const Component = /*#__PURE__*/react.createElement(Sidebar, props);
  return portal ? withPortal(Component) : Component;
};

const Sidebar = _ref2 => {
  let {
    children,
    visible,
    direction,
    timeTransition,
    onClickOutside,
    headerTitle,
    fullScreen
  } = _ref2,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["children", "visible", "direction", "timeTransition", "onClickOutside", "headerTitle", "fullScreen"]);

  const contentRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    var _contentRef$current;

    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = visible ? 'hidden' : originalStyle;
    if (contentRef != null && (_contentRef$current = contentRef.current) != null && _contentRef$current.scrollTop) contentRef.current.scrollTop = 0;
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [visible]);
  (0,react.useEffect)(() => {
    (0,lib/* forceVisible */.Iq)();
  }, [children]);
  return /*#__PURE__*/react.createElement(Container, {
    visible: visible,
    "data-testid": "sidebar"
  }, /*#__PURE__*/react.createElement(Content, (0,esm_extends/* default */.Z)({
    forwardRef: contentRef,
    visible: visible,
    direction: direction,
    timeTransition: timeTransition,
    fullScreen: fullScreen,
    "data-testid": "content"
  }, props), headerTitle && /*#__PURE__*/react.createElement(SidebarHeader/* default */.Z, {
    label: headerTitle,
    leftButton: {
      onClick: onClickOutside
    }
  }), children), /*#__PURE__*/react.createElement(Overlay, {
    "aria-hidden": "true",
    visible: visible,
    onClick: onClickOutside,
    "data-testid": "overlay"
  }));
};

 false ? 0 : void 0;
Sidebar.defaultProps = {
  direction: 'left',
  timeTransition: 0.3,
  headerTitle: null,
  fullScreen: false,
  visible: false,
  onClickOutside: () => {}
};
SidebarWrapper.Header = sidebar_header;
/* harmony default export */ var sidebar = (SidebarWrapper);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js



/* harmony default export */ var organisms_Sidebar = (sidebar);

/***/ }),

/***/ 37215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ tag_international; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js + 2 modules
var Chip = __webpack_require__(17781);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/tag-international.styles.js


const variantionsSize = {
  xsmall: {
    size: 'xsmall',
    width: '15px',
    height: '15px',
    minWidth: '152px',
    maxWidth: '152px',
    fontSize: 0
  },
  small: {
    size: 'small',
    width: '17px',
    height: '17px',
    minWidth: '153px',
    maxWidth: '153px',
    fontSize: 1
  },
  medium: {
    size: 'medium',
    width: '20px',
    height: '18px',
    minWidth: '160px',
    maxWidth: '160px',
    fontSize: 1
  }
};
const Container = (0,styled_components_browser_esm/* default */.ZP)(Chip/* default */.Z).attrs(({
  variant,
  startIcon
}) => ({
  bg: 'magabluLight',
  fontSize: 0,
  startIcon,
  fontWeight: 'medium',
  gridGap: 1,
  borderRadius: 8,
  mb: 2,
  mt: 2,
  color: 'primary',
  justify: 'start',
  padding: '2px 8px',
  minWidth: variantionsSize[variant].minWidth,
  maxWidth: variantionsSize[variant].maxWidth,
  textMaxWidth: 'auto',
  size: variantionsSize[variant].size
}))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/tag-international.js





function TagInternational({
  variant
}) {
  return /*#__PURE__*/react.createElement(Container, {
    variant: variant,
    "data-testid": "productCard-international-tag",
    startIcon: /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: "Airplane",
      fill: "#0086FF",
      width: variantionsSize[variant].width,
      height: variantionsSize[variant].height
    })
  }, "Compra Internacional");
}

TagInternational.defaultProps = {
  variant: 'xsmall'
};
 false ? 0 : void 0;
/* harmony default export */ var tag_international = (TagInternational);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js


/***/ }),

/***/ 35306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ text_list; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/text-list.styles.js



const variationsList = {
  default: styled_components_browser_esm/* css */.iv`
    flex-direction: column;
    word-break: break-word;
    min-width: 280px;
  `,
  flex: styled_components_browser_esm/* css */.iv`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: space-between;
    ${(0,esm/* getMediaQuery */.aK)('small')} {
      justify-content: left;
    }
  `,
  inline: styled_components_browser_esm/* css */.iv`
    display: inline;
    font-size: inherit;
    line-height: normal;
  `
};
const variationsItem = {
  flex: styled_components_browser_esm/* css */.iv`
    display: inline-block;
    padding: ${(0,esm/* themeGet */.R)('space.3')}px ${(0,esm/* themeGet */.R)('space.2')}px;
    ${(0,esm/* getMediaQuery */.aK)('small')} {
      width: 150px;
      padding: unset;
    }
  `,
  inline: styled_components_browser_esm/* css */.iv`
    display: inline-block;
    margin-right: ${(0,esm/* themeGet */.R)('space.4')}px;
    font-size: inherit;
    & a {
      display: inline-block;
      font-size: inherit;
      line-height: normal;
    }
  `
};
const variationTitle = {
  default: styled_components_browser_esm/* css */.iv`
    color: ${props => (0,esm/* getTextColor */.uu)('base')(props)};
    padding-bottom: ${(0,esm/* themeGet */.R)('space.3')}px;
    line-height: normal;
  `,
  inline: styled_components_browser_esm/* css */.iv`
    display: inline-block;
    margin-right: ${(0,esm/* themeGet */.R)('space.3')}px;
    font-size: inherit;
  `
};
const Container = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Box */.xu).attrs(props => Object.assign({
  p: 3,
  textAlign: 'left',
  borderRadius: 'default'
}, props))``;
const Title = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Heading */.X6)`
  ${props => variationTitle[props.variation] || variationTitle.default};
`;
const HorizontalRule = (0,styled_components_browser_esm/* default */.ZP)(atoms/* HorizontalRule */.bo)`
  ${(0,esm/* getMediaQuery */.aK)('small')} {
    display: none;
  }
`;
const List = styled_components_browser_esm/* default.ul */.ZP.ul`
  list-style-position: inside;
  display: flex;
  justify-content: space-around;
  ${props => variationsList[props.variation] || variationsList.default};
`;
const Item = (0,styled_components_browser_esm/* default */.ZP)(atoms/* Text */.xv).attrs(() => ({
  forwardedAs: 'li',
  fontSize: 2,
  color: 'scratched',
  lineHeight: 'big'
}))`
  list-style-type: ${({
  hideListPoint
}) => hideListPoint ? 'none' : 'disc'};
  ${props => variationsItem[props.variation] || variationsItem.default};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/text-list.js








const TextList = _ref => {
  let {
    hideListPoint,
    limitListItems,
    list,
    handleClickLink,
    showAllItems,
    showMoreLabel,
    title,
    titleAs,
    typeList
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["hideListPoint", "limitListItems", "list", "handleClickLink", "showAllItems", "showMoreLabel", "title", "titleAs", "typeList"]);

  const [showAll, setShowAll] = (0,react.useState)(showAllItems);
  const [items, setItems] = (0,react.useState)(list.slice(0, limitListItems));

  const handleShowMore = () => {
    setShowAll(true);
    setItems(list);
  };

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "text-list-container"
  }, props, {
    variation: typeList
  }), title && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Title, {
    "data-testid": "text-list-title",
    as: titleAs,
    variation: typeList
  }, title), typeList !== 'inline' && /*#__PURE__*/react.createElement(HorizontalRule, {
    variation: typeList
  })), /*#__PURE__*/react.createElement(List, {
    "data-testid": "text-list-ul",
    variation: typeList
  }, items.map((line, index) => /*#__PURE__*/react.createElement(Item, {
    variation: typeList,
    hide: !showAll && index >= limitListItems,
    key: index,
    "data-testid": "text-list-text",
    hideListPoint: hideListPoint
  }, /*#__PURE__*/react.createElement(molecules/* DynamicText */.g0, {
    data: line,
    handleClickLink: handleClickLink
  })))), !showAll && items.length >= limitListItems && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(HorizontalRule, null), /*#__PURE__*/react.createElement(atoms/* Item */.ck, {
    fontWeight: "medium",
    fontSize: 1,
    color: "text.primary",
    fill: "text.primary",
    startIcon: "ChevronDownCircle",
    variant: "transparent",
    gap: 1,
    centered: true,
    onClick: handleShowMore,
    "data-testid": "term-list-more"
  }, showMoreLabel)));
};

TextList.defaultProps = {
  hideListPoint: false,
  limitListItems: 20,
  list: [],
  handleClickLink: () => {},
  showAllItems: true,
  showMoreLabel: 'veja mais',
  title: null,
  titleAs: 'h1',
  typeList: 'default'
};
 false ? 0 : void 0;
/* harmony default export */ var text_list = (TextList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/index.js


/***/ }),

/***/ 41323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ zip_code_bar; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/ZipcodeText/index.js + 2 modules
var ZipcodeText = __webpack_require__(1587);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/zip-code-bar.styles.js




const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'background.primaryDark',
  padding: 1
}))``;
const ChevronRightIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* ChevronRight */._Qn).attrs(props => ({
  color: (0,esm/* getTextColor */.uu)('lightest')(props)
}))``;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/zip-code-bar.js







const ZipcodeBar = _ref => {
  let {
    text,
    defaultText,
    zipcode,
    state,
    city,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["text", "defaultText", "zipcode", "state", "city", "onClick"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    onClick: onClick,
    "data-testid": "container"
  }, props), /*#__PURE__*/react.createElement(ZipcodeText/* default */.Z, {
    city: city,
    defaultText: defaultText,
    state: state,
    text: text,
    zipcode: zipcode,
    iconHeight: 18,
    iconWidth: 20
  }), /*#__PURE__*/react.createElement(ChevronRightIcon, null));
};

ZipcodeBar.defaultProps = {
  zipcode: undefined,
  state: undefined,
  city: undefined
};
 false ? 0 : void 0;
/* harmony default export */ var zip_code_bar = (ZipcodeBar);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/index.js


/***/ }),

/***/ 46514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dO": function() { return /* reexport */ AttributeList/* default */.Z; },
  "G4": function() { return /* reexport */ filter_item_attribute; },
  "jm": function() { return /* reexport */ filter_item_container; },
  "aw": function() { return /* reexport */ filter_item_price; },
  "pZ": function() { return /* reexport */ filter_item_review; },
  "f4": function() { return /* reexport */ HeaderLinks_HeaderLinks; },
  "DH": function() { return /* reexport */ links_menu; },
  "Il": function() { return /* reexport */ ProductCard/* default */.Z; },
  "zT": function() { return /* reexport */ ProductReviewGallery/* default */.Z; },
  "Qp": function() { return /* reexport */ ProductReviewPopup/* default */.Z; },
  "Ak": function() { return /* reexport */ review_card; },
  "Ym": function() { return /* reexport */ review_characteristics; },
  "fP": function() { return /* reexport */ SellerDelivery/* default */.Z; },
  "u0": function() { return /* reexport */ ShippingList/* default */.Z; },
  "YE": function() { return /* reexport */ Sidebar/* default */.Z; }
});

// UNUSED EXPORTS: ActionCard, ActionDetail, BestInstallment, CardanFormFull, CardanFormLicensePlate, DeliveryGuarantee, FastFilter, FilterDelivery, ImportTaxes, LetMeKnow, LoyaltyCommission, MediaGallery, OpinionSnippetBlock, ProductCardHorizontal, ProductCarousel, ProductList, ReviewStats, Showcase, TagInternational, TextList, ZipcodeBar

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionCard/index.js + 2 modules
var ActionCard = __webpack_require__(5530);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ActionDetail/index.js + 2 modules
var ActionDetail = __webpack_require__(92877);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/AttributeList/index.js + 1 modules
var AttributeList = __webpack_require__(36103);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/BestInstallment/index.js + 3 modules
var BestInstallment = __webpack_require__(88586);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormFull/index.js + 2 modules
var CardanFormFull = __webpack_require__(18559);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/CardanFormLicensePlate/index.js + 2 modules
var CardanFormLicensePlate = __webpack_require__(37331);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/DeliveryGuarantee/index.js + 4 modules
var DeliveryGuarantee = __webpack_require__(28426);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterDelivery/index.js + 2 modules
var FilterDelivery = __webpack_require__(63486);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterItem/index.js + 2 modules
var FilterItem = __webpack_require__(1729);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Sidebar/index.js + 3 modules
var Sidebar = __webpack_require__(70615);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/FilterInput/index.js + 2 modules
var FilterInput = __webpack_require__(99554);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/filter-item-container.styles.js




const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('lighter')(props)};
  border-bottom: 1px solid ${props => (0,build_esm/* getBackgroundColor */.dF)('darker')(props)};
  border-top: 1px solid ${props => (0,build_esm/* getBackgroundColor */.dF)('darker')(props)};
  padding: 14px 16px;
`;
const Content = styled_components_browser_esm/* default.div */.ZP.div``;
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)``;
const FilterSelected = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  margin: 4px 0;
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
`;
const FilterDetailTitleContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 20px 16px;
  border-bottom: 1px solid ${props => (0,build_esm/* getBackgroundColor */.dF)('darker')(props)};
  margin-bottom: 0.5em;
`;
const TitleContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/filter-item-container.js









const FilterItemContainer = _ref => {
  let {
    onClick,
    label,
    position,
    filterSelected,
    fullScreen,
    showFilterInput,
    onChangeFilterInput,
    onClearInput,
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onClick", "label", "position", "filterSelected", "fullScreen", "showFilterInput", "onChangeFilterInput", "onClearInput", "children"]);

  const [showFilterItemDetail, setShowFilterDetail] = (0,react.useState)(false);

  const handleOnClick = () => {
    setShowFilterDetail(true);
    onClick({
      label,
      position
    });
  };

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    onClick: handleOnClick,
    "data-testid": "filter-item-container"
  }), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Title, {
    fontSize: 1,
    "data-testid": "filter-item-container"
  }, label), filterSelected && /*#__PURE__*/react.createElement(FilterSelected, {
    as: typeof filterSelected !== 'string' ? 'div' : 'p',
    fontSize: 0,
    "data-testid": "filter-item-selected"
  }, filterSelected)), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(esm/* ArrowRight */.olP, {
    width: "12px",
    height: "12px"
  }))), /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(Sidebar/* default */.Z, {
    direction: "right",
    visible: showFilterItemDetail,
    onClickOutside: () => setShowFilterDetail(false),
    fullScreen: fullScreen
  }, /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(FilterDetailTitleContainer, null, /*#__PURE__*/react.createElement(Content, null, /*#__PURE__*/react.createElement(esm/* ArrowBack */.xhZ, {
    color: "#8c8c8c",
    "data-testid": "close-filter-detail",
    role: "button",
    title: "Fechar filtro",
    onClick: () => setShowFilterDetail(false)
  })), /*#__PURE__*/react.createElement(TitleContainer, null, /*#__PURE__*/react.createElement(Title, {
    fontSize: 1,
    textAlign: "center",
    fontWeight: "500"
  }, label))), /*#__PURE__*/react.createElement("div", null, showFilterInput && /*#__PURE__*/react.createElement(FilterInput/* default */.Z, {
    m: '20px',
    onChange: onChangeFilterInput,
    onClearInput: onClearInput,
    label: label
  })), children))));
};

FilterItemContainer.defaultProps = {
  filterSelected: '',
  onClick: () => ({}),
  fullScreen: false
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_container = (FilterItemContainer);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemContainer/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sortBySelected.js
var sortBySelected = __webpack_require__(41869);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemAttribute/filter-item-attribute.js







const filter = (input = '', items = []) => {
  return items.filter(item => {
    var _item$label, _item$label$toUpperCa;

    return (_item$label = item.label) == null ? void 0 : (_item$label$toUpperCa = _item$label.toUpperCase()) == null ? void 0 : _item$label$toUpperCa.includes(input.toUpperCase());
  });
};

const FilterItemAttribute = _ref => {
  let {
    fullScreen,
    label,
    position,
    filterSelected,
    items,
    showFilterInput,
    onItemClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullScreen", "label", "position", "filterSelected", "items", "showFilterInput", "onItemClick"]);

  const [filterItems, setFilterItems] = (0,react.useState)((0,sortBySelected/* default */.Z)(items));
  (0,react.useEffect)(() => {
    setFilterItems((0,sortBySelected/* default */.Z)(items));
    return () => setFilterItems([]);
  }, [items]);

  const handleClearInput = () => {
    setFilterItems(items);
  };

  const handleChangeFilterInput = e => {
    setFilterItems((0,sortBySelected/* default */.Z)(filter(e.target.value, items)));
  };

  return /*#__PURE__*/react.createElement(filter_item_container, (0,esm_extends/* default */.Z)({}, props, {
    label: label,
    position: position,
    fullScreen: fullScreen,
    onChangeFilterInput: handleChangeFilterInput,
    onClearInput: handleClearInput,
    filterSelected: filterSelected,
    showFilterInput: showFilterInput
  }), /*#__PURE__*/react.createElement("ul", null, filterItems.map((item, idx) => /*#__PURE__*/react.createElement(FilterItem/* default */.Z, {
    item: item,
    key: (item == null ? void 0 : item.slug) || idx,
    onClick: onItemClick
  }))));
};

FilterItemAttribute.defaultProps = {
  label: '',
  filterSelected: '',
  items: [],
  showFilterInput: false,
  onItemClick: () => ({})
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_attribute = (FilterItemAttribute);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemAttribute/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/index.js + 33 modules
var molecules = __webpack_require__(39146);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/sortDescByValue.js
var sortDescByValue = __webpack_require__(82260);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemReview/filter-item-review.js








const FilterItemReview = _ref => {
  let {
    fullScreen,
    label,
    position,
    filterSelected,
    items,
    onItemClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullScreen", "label", "position", "filterSelected", "items", "showFilterInput", "onItemClick"]);

  const [filterRating, setFilterRating] = (0,react.useState)((0,sortDescByValue/* default */.Z)(items));
  (0,react.useEffect)(() => {
    setFilterRating(items);
    return () => setFilterRating({});
  }, [items]);
  return /*#__PURE__*/react.createElement(filter_item_container, (0,esm_extends/* default */.Z)({
    position: position,
    label: label,
    fullScreen: fullScreen,
    filterSelected: filterSelected && Object.keys(filterSelected).length ? /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
      min: 0,
      max: 5,
      score: filterSelected == null ? void 0 : filterSelected.value,
      label: filterSelected == null ? void 0 : filterSelected.hint,
      format: "label",
      fontSize: "14px",
      width: "20px",
      height: "20px"
    }) : undefined
  }, props), filterRating.map((item, idx) => /*#__PURE__*/react.createElement("ul", {
    key: (item == null ? void 0 : item.slug) || idx
  }, /*#__PURE__*/react.createElement(molecules/* FilterItem */.L2, {
    onClick: onItemClick,
    item: item
  }, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    min: 0,
    max: 5,
    score: item == null ? void 0 : item.value,
    label: item == null ? void 0 : item.hint,
    format: "label",
    fontSize: "14px",
    width: "20px",
    height: "20px",
    "data-testid": "review-item"
  })))));
};

FilterItemReview.defaultProps = {
  filterSelected: [],
  items: [],
  showFilterInput: false,
  onItemClick: () => {},
  onClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_review = (FilterItemReview);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemReview/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/index.js
var stereo_ui_utils_build_esm = __webpack_require__(71180);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemPrice/filter-item-price.js








const FilterItemPrice = _ref => {
  let {
    fullScreen,
    label,
    position,
    onApply,
    min,
    max,
    selectedMin,
    selectedMax,
    item
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["fullScreen", "label", "position", "onApply", "min", "max", "selectedMin", "selectedMax", "item"]);

  return /*#__PURE__*/react.createElement(filter_item_container, (0,esm_extends/* default */.Z)({
    id: "filter-item-price-container",
    position: position,
    label: label,
    fullScreen: fullScreen,
    filterSelected: selectedMin || selectedMax ? `${(0,stereo_ui_utils_build_esm/* currencyFormatter */.oB)({
      value: selectedMin
    })} - ${(0,stereo_ui_utils_build_esm/* currencyFormatter */.oB)({
      value: selectedMax
    })}` : undefined
  }, props), /*#__PURE__*/react.createElement(molecules/* PriceRange */.MS, {
    min: min,
    max: max,
    initialMin: selectedMin,
    initialMax: selectedMax,
    onApply: onApply,
    item: item
  }));
};

FilterItemPrice.defaultProps = {
  onApply: () => {},
  onClick: () => {},
  item: {}
};
 false ? 0 : void 0;
/* harmony default export */ var filter_item_price = (FilterItemPrice);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FilterItemPrice/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ImportTaxes/index.js + 4 modules
var ImportTaxes = __webpack_require__(66608);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LetMeKnow/index.js + 2 modules
var LetMeKnow = __webpack_require__(75057);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LinksMenu/links-menu.styles.js





const NavMenuContainer = styled_components_browser_esm/* default.nav.attrs */.ZP.nav.attrs(props => Object.assign({
  bg: 'background.primary'
}, props))`
  text-align: left;

  ${build_esm/* color */.$_}
`;
const NavMenu = styled_components_browser_esm/* default.ul.attrs */.ZP.ul.attrs(props => Object.assign({
  my: 0,
  pl: 0
}, props))`
  display: flex;
  align-items: center;
  line-height: 45px;
  list-style: none;
  white-space: nowrap;
  justify-content: space-between;

  ${index_esm/* space */.Dh}
`;
const links_menu_styles_Link = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).attrs(props => Object.assign({
  color: 'text.white',
  px: '10px',
  underlineOnHover: false
}, props))`
  ${build_esm/* color */.$_}
`;
const NavSubmenu = styled_components_browser_esm/* default.div */.ZP.div`
  position: absolute;
  background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('white')(props)};
  z-index: ${props => (0,build_esm/* themeGet */.R)('zIndices.4')(props)};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  opacity: ${props => props.show ? 1 : 0};
  pointer-events: ${props => props.show ? 'auto' : 'none'};
  transition: opacity 0;
`;
const NavMenuItem = styled_components_browser_esm/* default.li */.ZP.li`
  display: inline-block;
  position: relative;
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  z-index: ${props => props.selected ? (0,build_esm/* themeGet */.R)('zIndices.1')(props) : 'auto'};
  background-color: ${props => props.selected ? (0,build_esm/* getBackgroundColor */.dF)('white')(props) : 'transparent'};

  border-top-left-radius: ${props => props.selected ? '6px' : '0'};
  border-top-right-radius: ${props => props.selected ? '6px' : '0'};

  &:hover path {
    fill: ${props => props.colorOnHover || (0,build_esm/* getTextColor */.uu)('base')(props)};
  }

  &:hover > div > a {
    color: ${props => props.colorOnHover || (0,build_esm/* getTextColor */.uu)('base')(props)};
  }

  ${props => props.selected && styled_components_browser_esm/* css */.iv`
      & path {
        fill: ${props.colorOnHover || (0,build_esm/* getTextColor */.uu)('base')(props)} !important;
      }

      > div > a {
        color: ${props.colorOnHover || (0,build_esm/* getTextColor */.uu)('base')(props)} !important;
      }
    `}
`;
const MenuOverlay = styled_components_browser_esm/* default.div */.ZP.div`
  background: rgba(0, 0, 0, 0.6);
  animation: ${utils/* fadeIn */.Ji} 0.2s linear;

  position: fixed;
  z-index: ${props => (0,build_esm/* themeGet */.R)('zIndices.0')(props)};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  ${props => props.show ? styled_components_browser_esm/* css */.iv`
          display: block;
        ` : styled_components_browser_esm/* css */.iv`
          display: none;
        `};
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/MenuContent/index.js + 5 modules
var MenuContent = __webpack_require__(48919);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LinksMenu/links-menu.js







const hasSubMenuContent = menuItem => {
  const {
    banner,
    subcategoriesList
  } = menuItem || {};
  const {
    component
  } = banner || {};
  const {
    props
  } = component || {};
  const {
    static: staticProps
  } = props || {};
  const hasBannerPath = Boolean(staticProps == null ? void 0 : staticProps.path);
  const hasBannerSlot = Boolean(staticProps == null ? void 0 : staticProps.slot);
  const hasSubcategories = Array.isArray(subcategoriesList) && subcategoriesList.length > 0;
  return hasBannerPath || hasBannerSlot || hasSubcategories;
};

const LinksMenu = ({
  data,
  enableHoverDelay,
  onMenuItemClick,
  onHoverMenuItem,
  onClickMenuItem
}) => {
  const {
    categoryList,
    specialLinks,
    externalLinks,
    allCategories
  } = data;
  const {
    orderBy = [],
    list = [],
    show
  } = categoryList;
  const categList = (0,utils/* sortCategoriesList */.IC)(list, orderBy);
  const categItems = categList.slice(0, show || orderBy.length);
  const ctnMenuRef = (0,react.useRef)(null);
  const menuItemRefs = {};
  const subMenuItemRefs = {};
  const [submenuMargin, setSubmenuMargin] = (0,react.useState)(0);
  const [selectedSubmenu, setSelectSubmenu] = (0,react.useState)(null);
  const [submenuOpenOrigin, setSubmenuOpenOrigin] = (0,react.useState)(null);
  (0,utils/* useHideOverflownElements */.O)(menuItemRefs, ctnMenuRef, 'inline-block');

  const onItemMouseOver = key => {
    var _subMenuItemRefs$key;

    const subMenuEl = (_subMenuItemRefs$key = subMenuItemRefs[key]) == null ? void 0 : _subMenuItemRefs$key.current;

    if (subMenuEl) {
      subMenuEl.style.display = 'block';
      const subMenuWidth = subMenuEl.clientWidth;
      const itemOffset = menuItemRefs[key].current.offsetLeft;
      const headerWidth = ctnMenuRef.current.offsetWidth + ctnMenuRef.current.offsetLeft;
      const diff = itemOffset + subMenuWidth - headerWidth;
      setSubmenuMargin(diff >= 0 ? -diff : 0);
      subMenuEl.style.display = null;
    }
  };

  const handleSubMenu = (action, menu, key, origin = 'mouse') => {
    const shouldHandleSubMenu = hasSubMenuContent(menu);
    if (!shouldHandleSubMenu) return;

    if (action === 'open' && enableHoverDelay) {
      onItemMouseOver(key);
      setSelectSubmenu(key);
      setSubmenuOpenOrigin(origin);
    } else if (action === 'close') {
      setSelectSubmenu(null);
      setSubmenuOpenOrigin(null);
    }
  };

  const handleKeyDown = (e, menu, key) => {
    if (e.currentTarget !== e.target) return;
    const hasSubMenu = hasSubMenuContent(menu);

    if (e.key === 'Enter') {
      if (hasSubMenu) {
        handleSubMenu('open', menu, key, 'keyboard');
      } else {
        return;
      }
    }

    if (e.key === 'Escape' && selectedSubmenu === key) {
      var _menuItemRefs$key;

      e.preventDefault();
      handleSubMenu('close', menu, key);

      if ((_menuItemRefs$key = menuItemRefs[key]) != null && _menuItemRefs$key.current) {
        menuItemRefs[key].current.focus();
      }
    }
  };

  const renderSubmenu = (submenuData = {}, key) => {
    const handleSubmenuBlur = e => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        handleSubMenu('close', submenuData, key);
      }
    };

    return /*#__PURE__*/react.createElement(NavSubmenu, {
      marginLeft: submenuMargin,
      show: selectedSubmenu === key,
      "data-testid": "nav-submenu",
      ref: subMenuItemRefs[key],
      onBlur: handleSubmenuBlur,
      tabIndex: -1,
      onKeyDown: e => {
        if (e.key === 'Escape' && selectedSubmenu === key) {
          var _menuItemRefs$key2;

          e.preventDefault();
          handleSubMenu('close', submenuData, key);

          if ((_menuItemRefs$key2 = menuItemRefs[key]) != null && _menuItemRefs$key2.current) {
            menuItemRefs[key].current.focus();
          }
        }
      }
    }, /*#__PURE__*/react.createElement(MenuContent/* default */.Z, {
      data: submenuData,
      onMenuItemClick: (e, link, menuType) => {
        onMenuItemClick(e, link, submenuData.label, menuType);
        handleSubMenu('close', submenuData, key);
      }
    }));
  };

  const renderMenu = ({
    menuType,
    index,
    menu,
    icon,
    chevronDown = false
  }) => {
    const {
      color,
      label,
      url
    } = menu;
    const key = `${menuType}-item-${index}`;
    menuItemRefs[key] = (0,react.useRef)(null);
    subMenuItemRefs[key] = (0,react.useRef)(null);
    const hasSubMenu = hasSubMenuContent(menu);
    return /*#__PURE__*/react.createElement(NavMenuItem, {
      tabIndex: 0,
      selected: hasSubMenu && selectedSubmenu === key,
      "data-testid": "link-menu-item",
      key: key,
      colorOnHover: hasSubMenu ? '' : color,
      onMouseEnter: event => {
        event.stopPropagation();

        if (submenuOpenOrigin !== 'keyboard') {
          handleSubMenu('open', menu, key, 'mouse');
        }

        onHoverMenuItem(menu);
      },
      onMouseLeave: () => {
        if (submenuOpenOrigin === 'mouse') {
          handleSubMenu('close', menu, key);
        }
      },
      onKeyDown: e => handleKeyDown(e, menu, key),
      ref: menuItemRefs[key]
    }, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
      mx: "2px",
      justifyContent: "center",
      alignItems: "center"
    }, icon && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: icon,
      "data-testid": `link-icon-${index}`,
      color: "text.lightest"
    }), /*#__PURE__*/react.createElement(links_menu_styles_Link, {
      href: url,
      tabIndex: 0,
      onClick: event => {
        event.stopPropagation();
        onClickMenuItem(label);
      },
      onKeyDown: e => {
        if ((e.key === 'Enter' || e.keyCode === 13) && hasSubMenuContent(menu)) {
          e.preventDefault();
          handleSubMenu('open', menu, key, 'keyboard');
        }
      }
    }, label), chevronDown && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
      name: "ChevronDown",
      color: "text.lightest"
    })), renderSubmenu(menu, key));
  };

  return /*#__PURE__*/react.createElement(NavMenuContainer, {
    "data-testid": "links-menu",
    ref: ctnMenuRef
  }, /*#__PURE__*/react.createElement(NavMenu, null, renderMenu({
    menuType: 'main',
    index: 0,
    icon: 'Burger',
    menu: allCategories,
    chevronDown: true
  }), specialLinks.map((special, index) => renderMenu({
    menuType: 'special',
    index,
    menu: special
  })), categItems.map((category, index) => renderMenu({
    menuType: 'category',
    index,
    menu: category
  })), externalLinks.map((external, index) => renderMenu({
    menuType: 'external',
    index,
    menu: external,
    icon: external.id
  }))), /*#__PURE__*/react.createElement(MenuOverlay, {
    "data-testid": "menu-overlay",
    show: !!selectedSubmenu
  }));
};

 false ? 0 : void 0;
LinksMenu.defaultProps = {
  data: {
    categoryList: {},
    specialLinks: [],
    externalLinks: [],
    allCategories: {}
  },
  enableHoverDelay: true
};
/* harmony default export */ var links_menu = (LinksMenu);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LinksMenu/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/LoyaltyCommission/index.js + 2 modules
var LoyaltyCommission = __webpack_require__(99075);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/MediaGallery/index.js + 4 modules
var MediaGallery = __webpack_require__(60857);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/OpinionSnippetBlock/index.js + 3 modules
var OpinionSnippetBlock = __webpack_require__(56337);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCard/index.js + 13 modules
var ProductCard = __webpack_require__(43125);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCarousel/index.js + 1 modules
var ProductCarousel = __webpack_require__(4720);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductList/index.js + 3 modules
var ProductList = __webpack_require__(98284);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/HeaderLinks/header-links.styles.js



const mobileStyle = {
  height: 'auto',
  fontSize: 0,
  flexWrap: 'no-wrap',
  mt: 0,
  overflow: 'auto',
  px: '9px',
  pb: '5px'
};
const desktopStyle = {
  height: '16px',
  fontSize: 1,
  flexWrap: 'wrap',
  mt: 1,
  overflow: 'hidden'
};
const HeaderLinksContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  bg: 'background.primary'
}, props.isMobile ? Object.assign({}, mobileStyle) : Object.assign({}, desktopStyle), props))`
  white-space: pre;
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;

  a {
    font-size: inherit;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/HeaderLinks/HeaderLinks.js









const HeaderLinks = _ref => {
  let {
    data,
    onClick,
    isMobile,
    isRendered
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["data", "onClick", "isMobile", "isRendered"]);

  const {
    links,
    title
  } = data;
  if ((links == null ? void 0 : links.length) >= 1 && title) return /*#__PURE__*/react.createElement(HeaderLinksContainer, (0,esm_extends/* default */.Z)({
    display: isRendered ? 'flex' : 'none',
    "data-testid": "header-links-list",
    isMobile: isMobile
  }, props, {
    color: "text.lightest"
  }), /*#__PURE__*/react.createElement(Text/* default */.Z, {
    color: "text.lightest"
  }, `${title}: `), links == null ? void 0 : links.map((link, index) => {
    const pipe = index !== 0 && /*#__PURE__*/react.createElement("span", null, " | ");
    return /*#__PURE__*/react.createElement(react.Fragment, null, pipe, /*#__PURE__*/react.createElement(Link/* default */.Z, {
      "data-testid": "header-link",
      key: link.value,
      href: link.href,
      onClick: e => onClick(e, link),
      hover: false,
      color: "text.lightest"
    }, (0,utils/* capitalize */.kC)(link.value)));
  }));
  return null;
};

 false ? 0 : void 0;
HeaderLinks.defaultProps = {
  data: {
    links: [],
    title: ''
  },
  onClick: () => {},
  isMobile: false,
  isRendered: true
};
/* harmony default export */ var HeaderLinks_HeaderLinks = (HeaderLinks);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/HeaderLinks/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/formatDateDistance/index.js + 1 modules
var formatDateDistance = __webpack_require__(41544);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCharacteristics/review-characteristics.styles.js



const review_characteristics_styles_Container = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > ul {
    width: 100%;
    margin-top: 20px;
  }

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    flex-direction: row;
    width: 100%;

    > ul {
      width: ${({
  showScoreDesc
}) => !showScoreDesc ? '100%' : '50%'};
    }
  }
`;
const Main = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    flex-direction: column-reverse;
    flex: 1;
  }
`;
const review_characteristics_styles_Content = styled_components_browser_esm/* default.div */.ZP.div`
  margin-left: 8px;

  > div {
    margin-left: -4px;
  }
`;
const Line = styled_components_browser_esm/* default.li */.ZP.li`
  display: grid;
  grid-template-columns: 2fr 2fr auto;
  align-items: center;
  grid-gap: 8px;

  & > p:first-child {
    font-size: ${(0,build_esm/* themeGet */.R)('fontSizes.1')}px;
    line-height: ${(0,build_esm/* themeGet */.R)('lineHeights.display')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > p:last-child {
    font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.bold')(props)};
  }

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    grid-template-columns: 1fr 2fr auto;
  }
`;
const Score = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.7')(props)}px;

  & > span {
    display: none;
  }

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.fontSize')(props)};

    & > span {
      display: inline-block;
    }
  }
`;
const Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('light')(props)};

  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    margin-top: ${props => (0,build_esm/* themeGet */.R)('space.3')(props)}px;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCharacteristics/review-characteristics.js







function ReviewCharacteristics({
  average,
  count: total,
  characteristics,
  showScoreDesc
}) {
  const desc = total > 1 ? `${total} avaliações` : `${total} avaliação`;
  return /*#__PURE__*/react.createElement(review_characteristics_styles_Container, {
    showScoreDesc: showScoreDesc
  }, showScoreDesc && /*#__PURE__*/react.createElement(Main, null, /*#__PURE__*/react.createElement(Score, {
    "data-testid": "stat-score"
  }, /*#__PURE__*/react.createElement("span", null, "Nota:"), ` ${average.toFixed(1)}`), /*#__PURE__*/react.createElement(review_characteristics_styles_Content, null, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    score: average,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/react.createElement(Description, {
    "data-testid": "stat-desc"
  }, desc))), /*#__PURE__*/react.createElement("ul", null, characteristics == null ? void 0 : characteristics.map(item => /*#__PURE__*/react.createElement(Line, {
    key: item.label
  }, /*#__PURE__*/react.createElement(Text/* default */.Z, null, item.label), /*#__PURE__*/react.createElement(atoms/* LinearProgress */.uk, {
    height: "8px",
    color: "#0086ff",
    value: item.value,
    max: 5
  }), /*#__PURE__*/react.createElement(Text/* default */.Z, null, item.value.toFixed(1))))));
}

ReviewCharacteristics.defaultProps = {
  average: 0,
  count: 0,
  characteristics: [],
  showScoreDesc: true
};
 false ? 0 : void 0;
/* harmony default export */ var review_characteristics = (ReviewCharacteristics);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCharacteristics/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCard/review-card.styles.js




const review_card_styles_Container = styled_components_browser_esm/* default.div */.ZP.div`
  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    display: flex;
  }
`;
const TitleName = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  margin-top: 4px;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)(props.bold ? 'fontWeights.medium' : 'fontWeights.regular')(props)};
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};

  > span {
    color: ${props => (0,build_esm/* getTextColor */.uu)('lighter')(props)};
  }
`;
const TitleReview = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  margin-top: 12px;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.5')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  color: ${props => (0,build_esm/* getTextColor */.uu)('base')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.display')(props)};
`;
const review_card_styles_Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  margin: 12px 0;
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
  text-align: justify;
`;
const Divider = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  border-bottom: 3px solid ${props => (0,build_esm/* getBorderColor */.kJ)('light')(props)};
  margin: 16px 0px;
  width: 100%;
`;
const Recommended = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z)`
  font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};

  color: ${props => props.reviewOK ? (0,build_esm/* themeGet */.R)('baseColors.lima.base')(props) : (0,build_esm/* themeGet */.R)('baseColors.vermillion.base')(props)};
`;
const ContainerReview = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    width: 50%;
    flex: 1;
    margin-right: 32px;
  }
`;
const ContainerReviewCharacteristics = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  ${(0,build_esm/* getMediaQuery */.aK)('large')} {
    align-self: center;
    width: 50%;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCard/review-card.js







function ReviewCard({
  title,
  text,
  rating,
  recommended,
  user,
  date,
  characteristics,
  showScoreDesc
}) {
  const recoText = recommended ? 'Sim, eu recomendo esse produto' : 'Não, eu não recomendo esse produto';
  const days = date && (0,formatDateDistance/* default */.Z)(new Date(date), new Date());
  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(review_card_styles_Container, {
    "data-testid": "review-card"
  }, /*#__PURE__*/react.createElement(ContainerReview, null, /*#__PURE__*/react.createElement(molecules/* Review */.Cq, {
    score: rating,
    width: "20px",
    height: "20px"
  }), /*#__PURE__*/react.createElement(TitleName, null, (user == null ? void 0 : user.name) || 'Anônimo', " - ", /*#__PURE__*/react.createElement("span", null, "H\xE1 ", days)), /*#__PURE__*/react.createElement(TitleReview, {
    bold: true
  }, title), /*#__PURE__*/react.createElement(review_card_styles_Description, null, text), /*#__PURE__*/react.createElement(Recommended, {
    reviewOK: recommended
  }, recoText)), /*#__PURE__*/react.createElement(ContainerReviewCharacteristics, null, /*#__PURE__*/react.createElement(review_characteristics, {
    characteristics: characteristics,
    showScoreDesc: showScoreDesc
  }))), /*#__PURE__*/react.createElement(Divider, null));
}

ReviewCard.defaultProps = {
  user: {
    name: 'Anônimo'
  },
  showScoreDesc: false
};
 false ? 0 : void 0;
/* harmony default export */ var review_card = (ReviewCard);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewCard/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ReviewStats/index.js + 2 modules
var ReviewStats = __webpack_require__(4506);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewPopup/index.js + 11 modules
var ProductReviewPopup = __webpack_require__(77576);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/SellerDelivery/index.js + 5 modules
var SellerDelivery = __webpack_require__(30143);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ShippingList/index.js + 1 modules
var ShippingList = __webpack_require__(2334);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/Showcase/index.js + 10 modules
var Showcase = __webpack_require__(75335);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TextList/index.js + 2 modules
var TextList = __webpack_require__(35306);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ZipcodeBar/index.js + 2 modules
var ZipcodeBar = __webpack_require__(41323);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/index.js + 2 modules
var FastFilter = __webpack_require__(90713);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/TagInternational/index.js + 2 modules
var TagInternational = __webpack_require__(37215);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductReviewGallery/index.js + 3 modules
var ProductReviewGallery = __webpack_require__(99970);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/ProductCardHorizontal/index.js + 2 modules
var ProductCardHorizontal = __webpack_require__(3018);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/index.js





































/***/ })

}]);